export default {
	cadAeronave: {
		aviao: 'Avión',
		cadastroDeAeronave: 'Matricula de la Aeronave',
		ciclosT1: 'Ciclos Volados NF',
		ciclosVoados: 'Ciclos Volados',
		codinome: 'Nombre en clave',
		codinomeTipoIcao: 'Nombre en clave / Tipo ICAO',
		dadosAeroanve: 'Datos de la aeronave',
		dadosMotor: 'Datos del metor',
		dataFabricacao: 'Fecha de Fabricación',
		dataUltima: 'Fecha del último mantenimiento',
		etiqueta: 'Etiqueta',
		helicoptero: 'Helicóptero',
		horasVoadas: 'Horas de Vuelo',
		imei: 'IMEI',
		matricula: 'Registro',
		modelo: 'Modelo',
		modeloMotor: 'Modelo del Motor',
		motor: 'Motor',
		msgAtualizada: 'Aviones actualizado correctamente.',
		msgInserida: 'La inspección ha añadido correctamente.',
		novaAeronave: 'Nueva Aeronave',
		pousos: 'Aterrizaje',
		prefixo: 'Prefijo',
		registro: 'Registro',
		serialNumber: 'Número de série',
		serialNumberMotor: 'Número de série del motor',
		tailNumber: 'Prefijo',
		tipo: 'Tipo',
	},
	calendario: {
		domingo: 'domingo',
		hoje: 'Hoy',
		quartaFeira: 'miércoles',
		quintaFeira: 'jueves',
		segundaFeira: 'lunes',
		sextaFeira: 'viernes',
		sábado: 'sábado',
		terçaFeira: 'martes',
	},
	componentNatureza: {
		cAddItem: 'Ud. sólo puede agregar un ítem',
		cItem: 'No se ha agregado ningún ítem todavía',
		cItemAdicionado: 'Ítems ya agregados',
		cItemJaAdicionado: 'Este ítem ya se agregó',
		cNatureza: 'Naturaleza de la Ocurrencia',
		cTipo: 'Tipo de la Ocurrencia',
	},
	componentRAisp: {
		aisp: 'Aisp',
		risp: 'Risp',
	},
	conversao: {
		ano: 'año',
		anos: 'años',
		ciclo: 'ciclo',
		ciclos: 'ciclos',
		dia: 'día',
		dias: 'días',
		hora: 'hora',
		horas: 'horas',
		mes: 'mes',
		meses: 'meses',
	},
	cores: {
		amarelo: 'Amarillo',
		azul: 'Azul',
		cinza: 'Gris',
		laranja: 'Naranja',
		preto: 'Negro',
		roxo: 'Púrpura',
		verde: 'Verde',
		vermelho: 'Rojo',
	},
	diasSemana: {
		domingo: 'D',
		quarta: 'M',
		quinta: 'J',
		sabado: 'S',
		segunda: 'L',
		sexta: 'V',
		terca: 'M',
	},
	diasSemanaPos: {
		0: 'D',
		1: 'L',
		2: 'M',
		3: 'M',
		4: 'J',
		5: 'V',
		6: 'S',
	},
	gestao: {
		gestaoDe: 'Gestión',
	},
	global: {
		Altura: 'Altura',
		Desativando: 'Desactivando',
		Justificativa: 'Justificación',
		Marcacao: 'MARQUE LA FORMA DE EJECUCION DE LA MANIOBRA EN EL LUGAR CORRESPONDENTE',
		PDFICPBrasil: 'PDF ICP Brasil',
		PermissoesAcessoLayers: 'Permisos de acceso a capa',
		Por: 'Por',
		TipoDeEmbalagem: 'Tipo de embalaje',
		aOrdemInciaEm: 'El orden se iniciará en',
		aPartirDe: 'Desde',
		aQuantidadeFoiAlteradaComSucesso: 'La cantidad se ha modificado correctamente.',
		aRecomendacaoFoiSalvaComSucesso: 'La recomendación se guardó correctamente',
		aSolicitacaoEstaAprovada: 'La solicitud <strong>ESTÁ<strong> aprobada.',
		aSolicitacaoFoiDefinida: 'La solicitud se ha definido para el operador',
		aSolicitacaoNaoAval: 'La solicitud <strong>NO TIENE</strong> el aval de las operaciones.',
		aSolicitacaoNaoTemAprovacao: 'La solicitud <strong>NO ESTÁ<strong> aprobada.',
		aSolicitacaoNaoTemAvalManutencao: 'La solicitud <strong>NO TIENE</strong> el aval del mantenimiento.',
		aSolicitacaoTemAvalManutencao: 'La solicitud <strong>TIENE</strong> el aval del mantenimiento.',
		aSolicitaoTemOaval: 'La solicitud <strong>TIENE</strong> el aval de las operaciones.',
		aTarefaFoiAdicionadaComSucesso: 'La tarea se agregó correctamente',
		aTarefaFoiSalvaComSucesso: 'La tarea se ha guardado correctamente',
		abaixoDe: 'Abajo de',
		abaixoEstaoOsTrechosAgrupados: 'A continuación están los tramos agrupados.',
		abastecimentoAeronave: 'Suministro de Aeronaves',
		abastecimentoDeAeronaveFoiDeletadoComSucesso: 'El suministro de aeronaves se eliminó correctamente',
		abastecimentoDeAeronaveFoiSalvoComSucesso: '¡El suministro de aviones se salvó con éxito!',
		abastecimentoDeAeronaveViaApiContrato: 'Suministro de aeronaves a través de API/Contrato',
		abastecimentoDeAeronaveViaUnidadeDeArmazenamento: 'Suministro de aeronaves, a través de la Unidad de Almacenamiento',
		abastecimentoOleo: 'Suministro de petróleo (L)',
		aberta: 'Abierto',
		abertura: 'Apertura',
		abrirChat: 'Conversación abierta',
		acao: 'Acción',
		acaoCorretiva: 'Acción correctiva',
		acaoPreventiva: 'Acción Preventiva',
		acaoSalva: 'Acción Salva',
		acaoTomada: 'Acción Toma',
		acessar: 'Acceso',
		acessarApp: 'Acceder a App',
		acesso: 'Acceso',
		acessoExcluido: 'Acceso eliminado con éxito',
		acimaDe: 'Encima de',
		acimaDos: 'Por encima de los',
		acionamento: 'actuación',
		acoes: 'Acciones',
		acoesTomadas: 'Acciones',
		acumulado: 'Acumulado',
		acumuladoAno: 'Acumulado Año',
		acumuladoMes: 'Acumulado Mes',
		acumuladoNoPeriodo: 'Acumulado en el Período',
		adendo: 'Apéndice',
		adicaoOleoLubrificante: '¿Se ha añadido aceite lubricante?',
		adicionadoSucesso: 'Agregado exitosamente',
		adicional: 'Adicional',
		adicionar: 'ADICIONAR',
		adicionarAcao: 'Añadir Acción',
		adicionarAditivo: 'Agregar aditivo',
		adicionarAeronave: 'Añadir Aeronave',
		adicionarBase: 'Añadir la base',
		adicionarContato: 'Agregar contacto',
		adicionarDespacho: 'Añadir al despacho',
		adicionarDiscrepancia: 'Añadir Discrepancia',
		adicionarDocumentacao: 'Agregar documentación',
		adicionarFrequencia: 'Agregar frecuencia',
		adicionarInspecoes: 'Agregar Inspecciones',
		adicionarLayer: 'Agregar capa',
		adicionarNovoParecer: 'Agregar nueva opinión',
		adicionarOcorrencia: 'Añadir Ocurrencia',
		adicionarOrgao: 'Añadir Órgano',
		adicionarPagamento: 'AGREGAR PAGO',
		adicionarParecer: 'Agregar opinión',
		adicionarPassageiro: 'Añadir Pasajeros',
		adicionarPeloMenosUmaInspecao: 'Usted tiene que agregar al menos una inspección.',
		adicionarPontos: 'Añadir Puntos',
		adicionarProgramacaoVoo: 'Añadir horario de vuelo',
		adicionarRessalva: 'Añadir salvedad',
		adicionarTarefa: 'Agregar Tarea',
		adicionarTarefas: 'Agregar Tareas',
		adicionarTipoDeSolicitacao: 'Agregar tipo de solicitud',
		adicionarTrecho: 'Añadir Tramo',
		adicionarTripulacao: 'Añadir Tripulación',
		adicionarUnidade: 'Agregar unidad',
		adicionarValorAoContrato: 'Agregar valor al contrato',
		adicionarVoo: 'Agregar Vuelo',
		adicionePeloMenosUmaTarefaParaCadaGrupoDeInspecoes: 'Agregue al menos una tarea para cada grupo de inspección',
		adicioneUmRegistroDeLeitura: 'Agregue al menos un registro a la tabla de lectura obligatoria',
		aditivo: 'Aditivo',
		aditivoSalvoEContratoAtualizadoComSucesso: 'Aditivo guardado y contrato actualizado con éxito',
		aditivos: 'Adiciones',
		administracaoEscolar: 'Administración Escolar',
		administradorContrato: 'Supervisor / Administrador do Contrato',
		administradorSubstitutoDoContrato: 'Supervisor / Administrador suplente del contrato',
		administrativa: 'Administrativo',
		aeronavaArmazenamento: 'avión de almacenamiento de combustible',
		aeronave: 'Aeronave',
		aeronaveDestino: 'Destino de la aeronave',
		aeronaveDisponivel: 'Aviones disponibles',
		aeronaveIndisponivel: 'Aeronave no disponible',
		aeronaveNaoRetornouAoServico: 'La aeronave no retornó al servicio, ya que existe un(s) orden(s) abierto',
		aeronaveNãoEncontrada: 'Aeronave no encontrado',
		aeronaveParada: 'Aeronave detenida',
		aeronaveTurnoServico: 'Aeronave del turno de servicio',
		aeronavesAsasFixas: 'Aeronaves Asas Fijas',
		aeronavesAsasRotativas: 'Aeronaves Asas Rotativas',
		aeronavesEmpregadas: 'Aeronaves Empleadas',
		aeronavesOperadasPelo: 'Aeronaves Operadas por el',
		aeroporto: 'Aeropuerto',
		afastamentoVor: 'Distancia VOR(NM)',
		agrupado: 'Agrupados',
		agruparTrecho: 'Agrupar Tramo',
		agruparTrechos: 'Agrupar Tramos',
		aguardandoLeitura: 'Esperando lectura',
		aindaNaoAvaliado: 'Aún no calificado',
		aindaNaoLido: 'Aún no leído',
		alergia: 'Alergia',
		alerta: 'Alerta',
		alinhaTabela: 'Alinear Tabla',
		almoco: 'Almuerzo',
		alocacao: 'Asignación',
		alta: 'Elevado',
		alteracao: 'Modificación',
		alteracoesEdicao: '¡Los cambios se guardaron y la firma se realizó con éxito!',
		alterandoAQuantidade: 'Cambiando la cantidad',
		alterandoSenha: 'Cambiar la contraseña',
		alterar: 'Cambio',
		alterarAQuantidade: 'Cambiar la cantidad',
		alterarAssinaturaNoProximoLogin: 'Cambiar la firma en el siguiente inicio de sesión?',
		alterarDespacho: 'Modificar el despacho',
		alterarProgramacaoVoo: 'Cambiar horario de vuelo',
		alterarSenha: 'Cambiar la contraseña',
		alterarSenhaProximoLogin: 'Cambiar la contraseña en el siguiente inicio de sesión?',
		alterarStatus: 'Alterar Estado',
		altitude: 'Altitud',
		altitudeTerreno: 'Altitud Absoluta',
		altitudeVelocidade: 'Altitud y velocidad',
		altura: 'Altura',
		alturaVoo: 'Altura del vuelo',
		aluno: 'Alumno',
		alunos: 'Alumnos',
		ambiente: 'Entorno',
		anac: 'Anac',
		anexeUmaImagem: 'Adjuntar una imagen',
		anexo: 'Anexo',
		anexoSolicitacao: 'Solicitud Anexo',
		ano: 'Año',
		anoFabricacao: 'Ano de Produção',
		anoModelo: 'Año Modelo',
		anos: 'Años',
		apareceraDespachoAeronaves: 'Aparecerá en el Despacho de Aeronaves hasta la opción \'Terminar este despacho?\' se marca como SIM.',
		aplicativoTelaLogin: 'Aplicación de pantalla de inicio de sesión',
		aplicavel: 'Aplicable',
		apoiados: 'Apoyado',
		aposSelecionarInspecao: 'Después de seleccionar todas las inspecciones que desee, haga clic en \'Agregar inspecciones\'.',
		apresentacao: 'Presentación',
		aprovacao: 'Aprobación',
		aprovado: 'Aprobado',
		aprovarEssaSolicitacao: 'Aprobar esta solicitud (Generar orden de misión)?',
		areaCriacao: 'Área de Creación',
		areaMapeamento: 'Área de Mapeo',
		areaMonitoramento: 'Área de Monitoreo',
		armasApreendidas: 'Armas aprehendidas',
		armazenamento: 'Almacenamiento',
		armazenamentoDisponivel: 'Almacenamiento de disponible',
		arquivo: 'Archivo',
		arquivosAusentesCorrompidos: 'Archivos Ausentes / Corrompidos',
		arrasteParaAumentarInferior: 'Arrastre para aumentar de tamaño en la esquina inferior derecha de la pantalla',
		as: 'para',
		asTarefasForamAdicionadasComSucesso: 'Las tareas se han agregado correctamente',
		asTarefasForamSalvasComSucesso: 'Las tareas se han guardado correctamente',
		assinadoDigitalmentePor: 'Firmado digitalmente por',
		assinadoPor: 'Firmado por',
		assinadosPorMim: 'Firmado por mí',
		assinando: 'Firma',
		assinar: 'Signo',
		assinarEFinalizar: 'Suscribirse y Finalizar',
		assinarESalvarTrecho: 'Suscribir y guardar tramo',
		assinarEletronicamente: 'Firmar electrónicamente',
		assinarInspetor: 'Suscribir Inspector',
		assinarManualmente: 'Firmar manualmente',
		assinarMecanico: 'Suscripción mecánica',
		assinarTodosOsTrechos: 'Suscribir todos los extractos',
		assinatura: 'FIRMA',
		assinaturaAvalicao: 'La firma debe tener 8 dígitos numéricos.',
		assinaturaDigialInspetor: 'Firmado digitalmente por el inspector',
		assinaturaDigital: 'Firma digital',
		assinaturaDigitalMecanico: 'Firmado digitalmente por el mecánico',
		assinaturaDigitalPilotoComando: 'Firmado digitalmente por el piloto en comando',
		assinaturaEletronica: 'Firma Electrónica',
		assinaturaInvalida: 'Firma no válida.',
		ate: 'para',
		atencaoEspecial: 'Atención especial',
		ativa: 'Activo',
		ativaEDesativaPrivilegios: 'Aquí HABILITAS o DESHABILITAS los privilegios que se mostrarán al cliente.',
		ativar: 'Activar',
		ativarInspecao: 'Activar Inspección',
		ativarInspecoes: 'Para activar esta inspección, se requiere una justificación',
		ativarTodasInspecoes: 'Para activar todas las inspecciones, se requiere una justificación',
		ativarUsuario: 'Activar el Usuario',
		atividade: 'Actividad',
		atividades: 'Actividades',
		atividadesAereas: 'Actividades Aereas',
		atividadesAereasGeral: 'Actividades Aéreas General',
		ativo: 'Activo',
		atualizaDadosFdm: 'Actualizar datos FDM',
		atualizacao: 'Actualización',
		atualizado: 'Actualizado',
		atualizando: 'Actualización',
		atualizandoLista: 'Actualizando lista',
		atualizandoModelosAeronaves: 'Actualización de los modelos de las aeronaves',
		atualizandoTempo: 'Actualizando el tiempo',
		atualizar: 'Actualizar',
		atualizarMapa: 'Actualizar Mapa',
		atualizarOrdemDeMissao: 'Actualizar Orden de Misión',
		atualizarOrdemServico: 'Actualizar orden de servicio',
		atualizarRoteiro: 'Actualizar Guión',
		atualizarSolicitacao: 'Actualizar solicitud',
		atualizarTrecho: 'Actualizar Tramo',
		auditoria: 'Auditoría',
		auditoriaDiarioDeBordo: 'Auditoría Diario de Bordo',
		aunqueNoFueCerrado: 'AUNQUE NO FUE CERRADO',
		ausentes: 'Ausente',
		autoLocalizacao: 'Auto Localización',
		autonomia: 'Autonomía',
		autorizacao: 'Autorización',
		aval: 'Endoso',
		avaliacao: 'Evaluación',
		avaliacaoGeral: 'EVALUACION GENERAL',
		avaliacaoQualitativa: ' Evaluación cualitativa',
		avaliacaoQualitativaAposAAplicacao: ' Evaluación cualitativa después de la aplicación de las recomendaciones',
		avaliar: 'Evaluar',
		avancado: 'Avanzado',
		avancar: 'Siguiente',
		avisoDeInicializacao: 'Advertencia de inicio',
		baco: 'Bazo',
		bagagemMao: 'Equipaje de Mano',
		bagagemPorao: 'Mantenga el Equipaje',
		bairro: 'Barrio',
		baixa: 'Bajo',
		baixar: 'Descargar',
		bambiBucket: 'Bambi Bucket',
		bancoDeDados: 'Banco de datos',
		base: 'Base',
		baseContratual: 'Base Contratual',
		baseContratualETransferencia: 'Bases contractuales y transferencias',
		baseDeOrigem: 'Base de Origen',
		baseOperacional: 'Base Operativa',
		basico: 'Básico',
		bilhete: 'Boleto',
		bilhetesDeEmbarque: '',
		brigadistas: 'bomberos',
		buscar: 'Digite para buscar en la lista a continuación',
		cCarregar: 'CARREGAR',
		cadComissaria: 'Registro de Comisaria',
		cadTipoHabilitacao: 'Registro de tipo de licencia',
		cadTripulacao: 'Registro de Tripulación',
		cadastrarImagens: 'Registrar imágenes',
		cadastro: 'Registro',
		cadastroAtividade: 'Registro de Actividad',
		cadastroCliente: 'Registro de cliente',
		cadastroCombustiveis: 'Registro de combustible',
		cadastroDeBase: 'Registro de Base',
		cadastroDeDepartamento: 'Registro de Departamento',
		cadastroDeDocumentacao: 'Registro de Documentación',
		cadastroDeFuncoes: 'Registro de Funciones',
		cadastroDeOvn: 'Registro de GVN(Gafas de Visión Nocturna)',
		cadastroDeSecao: 'Registro de sección',
		cadastroDeSessao: 'Registro de sesión',
		cadastroDeVeiculos: 'Registro de Vehículo',
		cadastroFornecedor: 'Registro de Proveedor',
		cadastroGrupoDePassageiros: 'Registro Grupo de Pasajeros',
		cadastroLayer: 'Registro de capa',
		cadastroMateriais: 'Registro de Materiales',
		cadastroMotor: 'Registro de motor',
		cadastroPassageiros: 'Registro de pasajeros',
		cadastroPontosInteresse: 'Registro de Puntos de Interés',
		cadastroRotaer: 'Registro de Rotaer',
		cadastroTipoArmazenamento: 'Registro Tipo Almacenamiento',
		cadastroTipoCarga: 'Registro de tipo de carga',
		cadastroTipoEmbalagem: 'Registro del Tipo de Paquete ',
		cadastroTipoVeiculo: 'Registro de tipo de vehículo',
		cadastroUnidadeConservacao: 'Registro de Unidad de Conservación',
		cadastroUnidadeOrcamentaria: 'Registro Unidad de Presupuesto',
		cadastroUsuarioSimplificado: 'Registro de Usuario Simplificado',
		cafeManha: 'Desayuno',
		calculoSistema: 'Cálculo en el sistema',
		calendarica: 'Calendárico',
		calendaricas: 'Calendáricas',
		calendarioDeManutencao: 'Calendario de mantenimiento',
		calendarioSemanal: 'Calendario Semanal',
		calor: 'Heat',
		caminha0: 'Camión',
		camp: 'Camp',
		campo1: 'Campo 1',
		campo2: 'Campo 2',
		campo3: 'Campo 3',
		campo4: 'Campo 4',
		campo5: 'Campo 5',
		campoObrigatorio: 'Este campo es obligatorio.',
		camposObrigatorios: 'Debe introducir los campos obligatorios.',
		camposOleoLubrificante: 'Campos de aceite lubrificante',
		camposWsdl: 'Campos WSDL',
		cancelaOrdemServico: 'Cancelar orden de servicio',
		cancelada: 'Cancelada',
		canceladaComSucesso: 'Cancelada con éxito',
		cancelando: 'Cancelando',
		cancelar: 'Cancelar',
		cancelarDespacho: 'Cancelar el envío',
		cancelarOrdem: 'Cancelar orden',
		cancelarOrdemServico: '¿Desea CANCELAR esta orden de servicio?',
		cancelarSelecao: 'Cancelar selección',
		capacidade: 'Capacidad',
		capacidadeMaxima: 'Maxima Capacidad',
		capacidadeMaximaMovimentacaoCombustivel: 'Maxima Capacidad (l)',
		capacidadeOuPotenciaOuCilindrada: 'Capacidad / Potencia / Capacidad del Cilindro',
		capitulo: 'Capítulo',
		caracteresRestantes: 'caracteres restantes.',
		carga: 'Cargar',
		cargaExcluidaComSucesso: 'Carga eliminada correctamente',
		cargaHoraria: 'Carga horaria',
		cargaLiquida: '¿Carga Líquida?',
		cargaSalvaComSucesso: 'Carga guardada con éxito',
		cargaTransportada: 'Carga Transportada',
		cargo: 'Cargo',
		carregaAutomaticoPerfilAoCriarUsuario: 'Cargar automáticamente este perfil al crear un nuevo usuario?',
		carregando: 'Cargando',
		carregandoComponentes: 'Cargando los componentes',
		carregandoDados: 'Cargando datos',
		carregandoDiario: 'Carga diaria de a bordo',
		carregandoDiarios: 'Cargando diarios',
		carregandoEntregas: 'Cargando entregas',
		carregandoHorimetro: 'Cargando horimetro',
		carregandoListas: 'Cargando Listas',
		carregandoMaisOpcoes: 'Cargando más opciones',
		carregandoManutencoes: 'Cargando mantenimiento',
		carregandoModelo: 'Cargando modelo',
		carregandoMovimentacoes: 'Cargar unidades',
		carregandoOrdemServico: 'Cargando Orden de servicio',
		carregandoPosicaoDoVoo: 'Posición de vuelo de carga',
		carregar: 'Cargar',
		carregarFoto: 'Cargar Foto',
		carregarModelo: 'Cargar Plantilla',
		carregarPosicaoDoVoo: 'Posición de vuelo de carga',
		carregarVoos: 'Cargar Vuelos',
		carrgandoFoto: 'Cargando foto',
		cartaDeSituacao: 'Carta de Situación',
		cartaDeSituacaoOperacoes: 'Carta de Situación Operaciones',
		casaDecimal: 'Requiere lugar decimal',
		casado: 'Casado(a)',
		categoria: 'Categoría',
		categoriaRegistro: 'Categoría de registro',
		centralizar: 'Centralizar',
		centroCusto: 'centro de coste',
		cep: 'Código Postal',
		ceso: 'Gestión de Riesgo',
		chamada: 'Llamada',
		chamadaDeSuporte: 'Llamada de soporte',
		chamadoSuporte: 'Llamados de Soporte',
		chassi: 'Chasis',
		chaveApi: 'Api Key',
		chaveServices: 'Key in Services',
		checkIn: 'checkin',
		chegada: 'Llegada',
		cicloTorque: 'Ciclo de Par',
		ciclos: 'Ciclos',
		ciclosNP: 'Ciclos NP',
		ciclosTotais: 'Ciclos Totales',
		cidade: 'Ciudad',
		cidadeDeVerificacao: 'Ciudad de Verificación',
		classificacao: 'Clasificación',
		classificacaoAtualizada: 'Clasificación actualizado',
		classificacaoDesativada: 'Calificación deshabilitada',
		classificacaoESub: 'Clasificación e Subclasificación',
		classificacaoExcluida: 'Clasificación excluida',
		classificacaoSalva: 'Clasificación salvo',
		clickExibirApp: 'Haga clic aquí para acceder al Followair de su teléfono.',
		clickParaVerOsTrechosAgrupados: 'Haga clic para ver los vuelos agrupados',
		clickParaVerOsTrechosPor: 'Haga clic para ver los vuelos agrupados por',
		clienteAtualizado: 'Cliente Actualizado',
		clienteSolicitante: 'Cliente solicitante',
		clientesSolicitantes: 'Clientes solicitantes',
		cliqueEmAlgumaImagem: 'Haga clic en cualquier imagen',
		cliqueEmCarregar: 'Haga clic en cargar después de escribir',
		cliqueEmNovoParaAdicionar: 'Haga clic en \'nuevo\' para agregar',
		cliqueNoHistoricoParaCarregar: 'haga clic en el historial para cargarlo.',
		cliqueParaConcluir: 'Click para terminar',
		cliqueParaVerAAssinatura: 'Haga clic para ver la firma',
		cliqueTrechoCarregar: 'Haga clic en el tramo para cargarlo.',
		cnpj: 'CNPJ',
		codigo: 'Código',
		codigoClassificacao: 'Código de clasificación',
		codigoDaSolicitacao: 'código de solicitud',
		codigoGeradoAoSalvar: 'Código generado al guardar',
		codigoGerenciamentoDeRisco: 'Código de gestión de riesgos',
		codigoInterno: 'Codigo Interno',
		codigoRenavan: 'Código Renavan',
		codigoSituacao: 'Código - situación',
		codinome: 'Con nombre en código',
		com: 'Con',
		comUmLink: 'con un enlace para recuperar su contraseña!',
		comandante: 'Comandante',
		comandanteLocalMissao: 'Comandante de la misión en el lugar',
		combustivel: 'Combustible',
		combustivelConsumido: 'Combustible Consumido',
		combustivelInicial: 'Combustible Inicial',
		combustivelTotal: 'Combustible Total',
		comoDesejaFiltar: 'Elija la forma que desea filtrar',
		complemento: 'Complemento',
		completo: 'Completo',
		componente: 'Componente',
		componenteCargaSolicitacao: 'Solicitud de carga de componentes',
		componentePassageiroSolicitacao: 'Solicitud de pasajero de componente',
		componenteTrechoSolicitacao: 'Solicitar componente de estiramiento',
		componentes: 'Componentes',
		computadorDeBordo: 'Computadora de Bordo',
		comunicacaoESO: 'Gestión de riesgos',
		comunicacoes: 'Comunicaciones',
		concluiEssaInspecao: 'Concluí esa Inspección',
		concluida: 'Completada',
		concluido: 'Terminado',
		concluidoNoTotalDe: 'completado en total de',
		concluir: 'Concluir',
		concluirDiscrepancia: 'Completar Discrepancia',
		conclusao: 'Conclusión',
		configBackend: 'Configuracion del Backend',
		confirmaExclusaoLeitores: 'Esta acción excluirá los lectores obligatorios ya insertados, ¿desea continuar?',
		confirmaLeitura: 'Confirma la lectura',
		confirmaLeituraDocumento: 'Usted confirma la lectura del documento?',
		confirmando: 'Confirmando',
		confirmar: 'Confirmar',
		confirmarDuplicar: 'Confirma que desea duplicar',
		conjuge: 'Cónyuge',
		consumados: 'Consumado',
		consumidoOValorTotalDoContrato: 'La cantidad total del contrato se consumió',
		consumidoOValorTotalDoEmpenho: 'La cantidad total de esfuerzo se consumió',
		consumivel: 'Consumible?',
		consumo: 'Consumo',
		consumoTotal: 'Consumo total',
		contato: 'Contacto',
		contatoDeEmergencia: 'Contacto de Emergencia',
		contatoEmCasoDeEmergencia: 'Contacto de emergencia',
		contatosMissao: 'Contactos de la Misión',
		contexto: 'Contexto',
		contextoAtualizado: 'Contexto operativo actualizado',
		contextoExcluido: 'Contexto Operativo excluido.',
		contextoOperativo: 'Contexto Operativo',
		contextoSalvo: 'Contexto Operativo salvo',
		continuar: 'Continuar',
		contrato: 'Contrato',
		contratoAtualizadoComSucesso: 'Contrato actualizado con éxito',
		contratoEmpenhoMovimentacao: 'Este contrato ya tiene un compromiso o está relacionado con un movimiento de combustible!',
		contratoExcluidoComSucesso: 'Contrato eliminado con éxito',
		contratoSalvoComSucesso: 'Contrato guardado correctamente',
		contratos: 'Contratos',
		contratosGenericos: 'Contratos Genéricos',
		controleDeInpencoesEManuais: 'Inspección y control manual',
		controleDePassageirosECargas: 'Control de pasajeros y carga',
		controleHorasOvn: 'Control de tiempo de gafas de visión nocturna',
		controleInpencoesComponentes: 'Control de Inspecciones y Componentes',
		copiandoDiario: 'Copiando diario de a bordo',
		copiar: 'Copia',
		copiarDespacho: 'Copiar el último envío',
		copiarOrdem: 'Copiar el última ordem',
		copiarSolicitacao: 'Copiar el última petición',
		copiloto: 'Copiloto',
		corIdentificacao: 'Color de identificación',
		corPolilyne: 'Color Polilyne',
		corPredominante: 'Color Predominante',
		coracao: 'Corazón',
		cornea: 'Córnea',
		corrijaOsCamposEmVermelho: 'Corrija los campos en rojo',
		corrompidos: 'Corrompido',
		corte: 'Cortada',
		cpfInvalido: 'Identidad inválida',
		cpfInvalidoOuJaCadastradoNoSistema: 'Identidad no válido o ya registrado en el sistema',
		cpfJaCadastrado: 'CPF ya registrado.',
		cpfUsadoComoLoginEsenha: 'El número de CPF se utilizará como LOGIN y CONTRASEÑA, que deberá cambiarse en el primer acceso.',
		crea: 'CREA',
		criar: 'Agregar',
		critica: 'Crítica',
		cumpridoConformeDocumentacaoReferencia: 'Cumplido conforme a la documentación de referencia.',
		dac: 'DAC',
		dadosDaMissao: 'Datos de la misión',
		dadosDaMissaoPreenchidos: 'Todos los datos de la orden de misión se han cumplido, está a la espera de entrar en ejecución.',
		dadosDaPrevencao: 'Datos de la Prevención',
		dadosDeMonitoramento: 'Dados de Monitoramento do Motor e Abastecimento de Óleo',
		dadosDoCliente: 'Datos del Cliente',
		dadosDoDespacho: 'Datos del Despacho',
		dadosDoVoo: 'Datos del vuelo',
		dadosFornecedor: 'Datos del Proveedor',
		dadosKit: 'Datos del Kit',
		dadosMotor: 'Datos del motor',
		dadosOleoEdicaoMecanico: 'La información referente al aceite lubricante fue editada por el mecánico',
		dadosProgramacaoVoo: 'Datos de horarios de vuelos',
		dashboardDadosSistema: 'Tablero de datos del sistema',
		data: 'Fecha',
		dataAbertura: 'Fecha de apertura',
		dataAcesso: 'Fecha de acceso',
		dataAtualMaiorUltimoTrecho: 'La fecha actual es mayor que el último tramo de la orden de misión.',
		dataCE: 'Fecha CE',
		dataCadastroOvn: 'Data de registro de gafas de visión nocturna',
		dataCompra: 'Fecha de compra',
		dataConclusao: 'Fecha de Finalización',
		dataCriacao: 'Fecha de criación',
		dataDaOcorrencia: 'Fecha de la ocurrencia',
		dataDeConclusao: 'Fecha de finalizacion',
		dataDeVerificacao: 'Fecha de Verificación',
		dataDoDiarioDeBordo: 'Fecha del libro de registro',
		dataEmissao: 'Fecha de emisión',
		dataEmissaoNotaFiscal: 'Fecha de emisión de la factura',
		dataExecucao: 'Fecha Ejecución',
		dataFabricacao: 'Date of fabrication',
		dataFim: 'Fecha Fin',
		dataFimIndisponibilidade: 'Indisponibilidad de la fecha de finalización',
		dataHoraCadastro: 'Fecha-Hora Registro',
		dataInicio: 'Fecha Inicio',
		dataInicioIndisponibilidade: 'Fecha de inicio de indisponibilidad',
		dataInicioOvn: 'Fecha de inicio de uso de gafas de visión nocturna',
		dataInvalida: 'Fecha Invalida',
		dataLeitura: 'Fecha de lectura',
		dataManutencao: 'Fecha Mantenimiento',
		dataNascimento: 'Fecha de Nacimiento',
		dataProcessamento: 'Fecha Procesamiento',
		dataServico: 'Fecha de servicio',
		dataSolicitacao: 'Fecha de solicitud',
		dataTermino: 'Fecha de finalización',
		dataTolerancia: 'Fecha de tolerancia',
		dc: 'dc',
		de: 'De',
		deTrabalho: 'trabajo',
		decimal: 'Decimal',
		decimo: 'Décimo',
		decolagem: 'Despegue',
		decolagemPrevista: 'Despegue programado',
		decolagemPrevisto: 'Decolagem previsto',
		defasagemVorI: 'Retraso VOR I',
		defasagemVorII: 'Retraso VOR II',
		definirComoPlanoDeFundo: 'Puesto como fondo',
		definirOperador: 'Definir Operador',
		definirPlanoDeFundo: 'Definir fondo',
		delito: 'Delito',
		demandaReprimida: 'Demanda Reprimida',
		departamento: 'Departamento',
		departamentoSolicitante: 'departamento solicitante',
		desabilitarInspecao: 'Desactivar inspección',
		desagrupando: 'Dispersante',
		desagruparTrechos: 'Desagrupar tramos',
		desativadoComSucesso: 'Desactivado correctamente',
		desativar: 'Desactivar',
		desativarInspecao: 'Desactivar la Inspección',
		desativarInspecoes: 'Para deshabilitar esta inspección, se requiere una justificación',
		desativarTodasInspecoes: 'Para deshabilitar todas las inspecciones, se requiere una justificación',
		desativarUsuario: 'Desactivar el Usuario',
		desconto: 'Descuento',
		descricao: 'Descripción',
		descricaoAlijamentosCarga: 'Descripción de los vertederos de carga',
		descricaoCapitulo: 'Descripción del capítulo',
		descricaoCompleta: 'Descripción completa',
		descricaoDaCarga: 'Descripción de la carga',
		descricaoDaMissao: 'Descripción de la misión',
		descricaoDaOrdem: 'Descripción de la orden',
		descricaoDoExercicio: 'Descripción del ejercicio',
		descricaoDoLocal: 'Descripción del sitio',
		descricaoDoTema: 'Descripción del tema',
		descricaoDosFatos: 'Descripción de los hechos',
		descricaoLavagemCompressor: 'Descripción del lavado del compresor',
		descricaoLayer: 'Descripción para capa',
		descricaoOrdemDeMissao: 'Descripción Orden de Misión',
		descricaoOrdemMissaoExcluidoComSucesso: 'Descripción Orden de Misión eliminado correctamente.',
		descricaoOrdemMissaoSalvoComSucesso: 'Descripción Orden de Misión se ha guardado correctamente.',
		descricaoResumida: 'Breve descripción',
		descricaoServico: 'Descripción del Servicio',
		descricaoStatus: 'Status',
		descricaoTipoArmazenamento: 'Descripción Tipo Almacenamiento',
		descricaoUnidadeCompra: 'Unidad de compra de presupuesto',
		desejaAdicionarAssinaturaPorLogin: '¿Quieres agregar una suscripción al iniciar sesión?',
		desejaAtivarEsseUsuario: '¿Desea habilitar este usuario?',
		desejaAtualizarTrecho: '¿Desea actualizar este tramo?',
		desejaCancelarEssePedido: '¿Quieres cancelar este pedido?',
		desejaCancelarPrevencao: '¿Desea CANCELAR esa prevención?',
		desejaCancelarSolicitacao: '¿Desea cancelar esta solicitud?',
		desejaConcluirEssaDiscrepancia: '¿Desea concluir esta discrepancia?',
		desejaContinuarAPrrencher: '¿Desea continuar llenando este diario de a bordo?',
		desejaDesativarEsseUsuario: '¿Desea deshabilitar este usuario?',
		desejaEncerrarEssaOrdemDeMissao: '¿Desea cerrar esta orden de misión?',
		desejaEncerrarEssaProgramacaoVoo: '¿Quieres terminar este horario de vuelo?',
		desejaEncerrarEsseDespacho: 'Desea cerrar este auto',
		desejaExcluir: 'Quieres borrar',
		desejaExcluirACarga: 'Quieres borrar la carga',
		desejaExcluirADocumentacao: 'Quieres borrar la documentación',
		desejaExcluirAcesso: 'Deseas eliminar lo acceso?',
		desejaExcluirCategoria: '¿Deseja eliminar categoria?',
		desejaExcluirClassificacao: '¿Desea eliminar esta clasificación?',
		desejaExcluirContexto: '¿Desea eliminar este contexto operativo?',
		desejaExcluirContrato: '¿Desea eliminar este contrato?',
		desejaExcluirEmbalagem: '¿Desea excluir este embalaje?',
		desejaExcluirEssaLeitura: '¿Quieres eliminar esta lectura obligatoria?',
		desejaExcluirEssaPermissao: '¿Realmente desea eliminar este permiso?',
		desejaExcluirEssaSolicitacao: '¿Desea eliminar esta solicitud?',
		desejaExcluirEsse: '¿Quieres borrar esto',
		desejaExcluirEsseDespacho: '¿Desea eliminar esta orden?',
		desejaExcluirEsseDocumento: '¿Quieres eliminar este documento?',
		desejaExcluirEsseEmpenho: '¿Quieres eliminar este esfuerzo?',
		desejaExcluirEsseLayer: '¿Quieres eliminar esta capa?',
		desejaExcluirEsseProduto: '¿Quieres eliminar este producto?',
		desejaExcluirEsseProdutoServico: 'Do you want to delete this product/service',
		desejaExcluirEsseTipo: '¿Quieres eliminar este Tipo?',
		desejaExcluirEsseTrecho: '¿Desea eliminar este fragmento?',
		desejaExcluirFornecedor: '¿Desea eliminar este proveedor?',
		desejaExcluirOTipoDeSolicitacao: '¿Quieres eliminar el tipo de solicitud?',
		desejaExcluirSubclassificacao: '¿Desea eliminar esta subclasificación?',
		desejaExcluirUnidadeMedida: '¿Quieres eliminar esta unidad de medida?',
		desejaFinalizarTrecho: '¿Desea finalizar este tramo?',
		desejaReabrirEssaOrdemMissao: '¿Quieres abrir esta Orden de Misión?',
		desejaRetornarOrdemMissaoExecucao: "¿Quieres devolver esta orden de misión a 'Running'?",
		desejaSelecionarvoo: '¿Usar un modelo de vuelo de malla?',
		desejada: 'Deseada',
		desembarque: 'N° ATERRIZAJE',
		desenvolvedorVejaOErroRetornadoPeloBackEnd: 'Desarrollador, vea el error devuelto por el backend',
		designativo: 'Designador',
		desmarcarTodos: 'Deseleccionar todo',
		desmarqueTrechosCarg: 'Desmarque las secciones que la carga no irá',
		desmarqueTrechosPass: 'Desmarque las secciones a las que no irá el pasajero',
		despacho: 'Despacho',
		despachoAeronaves: 'Despacho Aeronaves',
		despachoDeAeronaves: 'Despacho de Aeronaves',
		despachoEmergencial: 'Despacho Emergencial',
		despachoExcluido: 'Despacho Excluido',
		despachoGerado: 'Programa generado con éxito',
		despachoReaberto: 'Despacho Reabierto.',
		despachos: 'Despachos',
		despachosGerados: 'Órdenes Generadas',
		destinatario: 'Destinatario',
		destinatarios: 'destinatarios',
		destino: 'Destino',
		destinoAproximado: 'Destino Aproximado',
		detalhar: 'Detalle',
		detalhes: 'Detalles',
		detalhesDoPagamento: 'DETALLE DEL PAGO',
		determinacaoSessaoManutencao: 'Conforme a la determinación de la sesión de mantenimiento',
		deveConterMininoUm: 'Debe contener al menos 01',
		devolucaoPrevista: 'Regreso Esperado',
		devolvidoEm: 'Regresó el',
		diaAnterior: 'Dia anterior',
		diagonal: 'Diagonal',
		diarias: 'Diario',
		diario: 'Diario',
		diarioDeBordo: 'Diario de a Bordo',
		diarioDeBordoMecanico: 'Diario de Bordo Mecánico',
		diarioDeBordoOperador: 'Diario de Bordo Operador',
		diariosDeBordoNaoAssinados: 'Libros de registro sin firmar',
		dias: 'Días',
		diasMaisComuns: 'Día más común',
		diasRestantes: 'Días Restantes',
		diferencaUTC: 'Diferencia de UTC',
		digiteNovaSenhaAbaixo: 'Escriba la nueva contraseña en el campo siguiente.',
		digiteOItemQueDesejaBuscar: 'Ingrese el artículo que desea buscar',
		digiteParaRealizarUmaBuscaAvancada: 'Ingrese para realizar una búsqueda avanzada',
		digiteSeuLogin: 'Introduzca su nombre de usuario.',
		digiteSuaAssinatura: 'Introduzca su suscripción',
		digiteSuaSenhaParaRenovala: 'Introduzca su contraseña para renovarla.',
		direcao: 'Dirección',
		disciplina: 'Disciplina',
		disciplinaAtualizada: 'Disciplina actualizada',
		disciplinaInserida: 'Disciplina insertada',
		discrepancia: 'discrepancia',
		discrepanciaConcluida: 'Discrepancias concluidas',
		discrepanciaSalva: 'Discrepancia Salva',
		discrepancias: 'Discrepancias',
		discrepanciasTecnicas: 'Discrepancias Técnicas',
		discrepanciasVerificadas: 'Discrepancias Comprobadas',
		disponibilidade: 'Disponibilidad',
		disponibilizarAeronave: 'Disponibilizar Aeronave',
		disponivel: 'Disponible',
		disponivelNa: 'Disponible en',
		disponivelParaRetorno: 'Disponible para el retorno',
		distancia: 'Distancia',
		distanciaCalculada: 'Distancia Calculada',
		distanciaTotal: 'Distancia total',
		diurno: 'Diurno',
		divorciado: 'Divorciado(a)',
		documentacao: 'Documentación',
		documentacaoExcluidaComSucesso: 'Documentación eliminada correctamente',
		documentacaoSalva: 'Documentación Salva',
		documento: 'Documento',
		documentoExcluidoComSucesso: 'Documento eliminado con éxito.',
		documentoLeituraObrigatoria: 'Documento de lectura obligatoria',
		documentoObrigatorioExiste: 'El documento obligatorio ya existe en el sistema',
		documentoSalvoComSucesso: 'Documento guardado con éxito.',
		documentos: 'Documento(s)',
		documentosArmazenados: 'Documentos almacenados',
		documentosSemDuplicidade: 'CPF y Passport son los únicos documentos que evitan registros duplicados',
		download: 'Descargar',
		downloadAnexo: 'Descargar Anexo',
		duplicar: 'Duplicar',
		duracao: 'Duración',
		duracaoPrevistaJornada: 'DURACIÓN JORNADA DE TRABAJO PREVISTO',
		duracaoPrevistaVoo: 'Duración prevista del vuelo',
		e: 'y',
		eEstrangeiro: 'Es extranjero',
		eImportanteFazerEsseProcedimento: 'Es importante realizar este procedimiento antes de que la aeronave comience a volar',
		eOperador: 'es el operador',
		eUsuario: 'y Usuario',
		edicao: 'Edición',
		editar: 'Editar',
		editarCapitulo: 'Editar Capítulo',
		editarCategoria: 'Editar Categoría',
		editarHabilitacao: 'Editar licencia',
		editarMalha: 'editar malla',
		editarTrecho: 'Editar Tramo',
		editarUsuarioSimplificado: 'Editar Usuario Simplificado',
		efetividade: 'Efectividad',
		em: 'en',
		em2: 'en',
		emAberto: 'En abierto',
		emAnalise: 'En análisis',
		emBrancoMantemAssinatura: 'En blanco, mantenga la misma firma',
		emEstoque: 'En stock',
		emExecucao: 'En ejecución',
		emExecucaoOuAberta: 'En ejecución o abierta',
		emExecucaoVencida: 'En ejecución vencida',
		emHoras: 'En horas',
		emMeses: 'en Meses',
		emMesesDias: 'en meses y días',
		emMonitoramento: 'En seguimiento',
		emTolerancia: 'en tolerancia',
		emUso: 'en uso',
		email: 'Correo electrónico',
		emailAnac: 'E-mail ANAC',
		emailInvalido: 'E-mail no válido.',
		emailJaCadastrado: 'Correo electrónico ya registrado.',
		emailObrigatorio: 'Correo electrónico obligatorio',
		embalagemExcluidaComSucesso: 'Embalaje excluido con éxito.',
		embalagemJaCadastrada: 'Paquete ya registrado',
		embarcou: 'Abordado',
		embarque: 'Embarque',
		emergencia: 'Emergencia',
		emergencial: 'Emergencia',
		emissao: 'Emisión',
		empenhoExcluidoComSucesso: 'Esfuerzo eliminado con éxito',
		empenhoSalvoComSucesso: 'Compromiso guardado con éxito',
		empresa: 'Empresa',
		empresaEstrangeira: 'compañía extranjera',
		encaminharParaExecucao: 'Encaminhar a Ordem para execução',
		encerrada: 'Cerrado',
		encerrar: 'Cerrar',
		end: 'Dirección',
		endereco: 'Dirección',
		enderecoFuncional: 'Dirección Funcional',
		enderecoResidencial: 'Dirección Residencial',
		ensinoInfantil: 'Educação infantil',
		ensinoSuperior: 'Ensino Superior (Graduação)',
		enterSalvaEscCancela: 'ENTRAR para guardar y ESC para cancelar',
		entradaEfetuada: 'Registrado',
		entradaRegistrada: 'Entrada registrada',
		entregarSuprimentos: 'Entregar suministros',
		entregue: 'Entregado',
		enviamosUmEmail: 'Enviamos email para usted',
		enviando: 'Enviando',
		enviandoSuprimentos: 'Suministros de envío',
		enviar: 'Enviar',
		enviarArquivos: 'Enviar archivos',
		enviarSolicitacao: 'Enviar solicitud',
		envioNotificacoes: 'Envío de notificaciones',
		envolvidos: 'Involucrados',
		equipamentoTrocado: 'Equipo intercambiado',
		equipamentos: 'Equipamientos',
		equipe: 'Equipo',
		erroAoNotificar: 'Erro ao notificar',
		erroConectarServidor: 'Error al conectarse al servidor.',
		erroHorimetro: 'Contador de horas no completado en el registro de la aeronave',
		erroVor: 'Erro(grados)',
		esclero: 'Esclero',
		escola: 'Escuela',
		escolaDeVoo: 'Escuela de vuelo',
		escolaridade: 'Escolaridad',
		escolha: 'Elección',
		escolhaAFuncaoTripulante: 'Seleccione la función de este tripulante',
		escolhaAOrigem: 'Seleccione el origen',
		escolhaData: 'Elija una fecha',
		escolhaOMotivoCancelamentoOrdem: 'Seleccione el motivo para cancelar la solicitud',
		escolhaOpcaoAbaixo: 'Elija una acción a continuación',
		escolhaPeloMenosUmTrecho: 'Elija al menos un segmento por pasajero',
		escolhaPeloMenosUmTrechoCarga: 'Elija al menos un segmento por carga',
		escolhaUmEmpenhoParaOCampoValorSerLiberado: 'Elija un compromiso para el campo de valor que se liberará',
		escolhaUmTrechoParaCopiar: 'Elija un tramo para que usted copie.',
		escolhaUmaAcao: 'Elija una acción anterior.',
		escolhaUmaClassificacaoPara: 'Seleccione una clasificación<br/> para ver la lista.',
		escolhaUmaOpcaoAoLado: 'Elija una opción en el menú junto a.',
		escolhaUmaTabelaDoBancoDeDadosNaLista: 'Elija una tabla de base de datos de la lista',
		escolhaaTurma: 'Elegir una Clase',
		escolhaoAluno: 'Elegir un Alumno',
		escolhaoTreinamento: 'Elegir un Treinamento',
		escolherItemAcima: 'Tienes que elegir uno o más elementos anteriores.',
		esconderConcluidos: 'Esconder Terminadas',
		esconderDetalhes: 'Ocultar detalles',
		esconderItens: 'Ocultar elementos',
		escritorio: 'Escritório',
		esfera: 'Alcance',
		espacoEmDisco: 'Espacio en disco',
		espacoEmDiscoUtilizado: 'Espacio en disco usado',
		especial: 'Special',
		especieOuTipo: 'Especies/Tipo',
		esqueceuSuaSenha: 'Olvidaste tu contraseña?',
		esqueciMinhaSenha: 'Olvide mi contraseña',
		essaSolicitaoTemAvalManutencao: '¿Esta solicitud tiene el aval del Mantenimiento?',
		essaSolicitaoTemOaval: '¿Esta solicitud tiene el aval de la Operación?',
		esseDiarioDeBordoNaoEstaIntegroEntreEmContatoComOSuporte: 'Este libro de registro no está completo, comuníquese con el soporte.',
		esseMes: 'Ese mes',
		esseTrechoNaoPodeSerPreenchido: 'Este tramo no puede llenarse ahora',
		estaPreenchendoUmDiarioDeBordo: 'está llenando un diario para esa aeronave.',
		estado: 'Estado',
		estadoCivil: 'Estado Civil',
		estadoDeVerificacao: 'Estado de Verificación',
		estagiario: 'Aprendiz',
		estavaAtualizado: 'Se actualizó',
		esteCampoEObrigatorio: 'Este campo es requerido',
		estePerfilEhTripulante: 'Este perfil es tripulación',
		estoque: 'Stock',
		estoqueDisponivelSuprimentos: 'Disponible: NUEVO, USADO, REPARADO Y REVISADO',
		estoqueQuantidadeMinima: 'Cantidad mínima de producto en stock.',
		estoqueTotalSuprimentos: 'Stock total, incluidos ELIMINADOS Y DEFECTUOSOS',
		estoqueUnidadeMedida: 'Inventario - Unidades de Medida',
		estouCiente: 'Estoy consciente',
		evento: 'Evento',
		excelParaCompra: 'Excel para comprar',
		excelente: 'EXELENTE',
		excluidoComSucesso: 'Excluido con éxito.',
		excluindo: 'Excluyendo',
		excluir: 'Excluir',
		excluirContrato: 'Excluir Contrato',
		excluirFoto: 'Excluir Foto',
		excluirImagem: 'Eliminar Imagen',
		excluirLicenca: '¿Quieres eliminar esta licencia?',
		excluirPontoInteresse: 'Eliminar punto de interés',
		excluirUsuario: 'Excluyendo usuario',
		exclusaoLeitores: 'Exclusión de lectores obligatorios',
		execucao: 'Ejecución',
		executado: 'Ejecutado',
		exercicio: 'EJERCICIO',
		exercicios: 'Ejercicios',
		exibeAnuncio: 'Muestra anuncios',
		exibir: 'Exhibir',
		exibirConcluidos: 'Mostrar completadas',
		exibirDadosDiarioBordo: 'Los datos se rellenarán tras rellenar el CE y número de aeronave según bitácora',
		exibirDesativados: 'Ver Deshabilitados',
		exibirEncerradas: 'Mostrar Cerradas',
		exibirLegendas: 'Ver subtítulos',
		exibirTodas: 'Mostrar Todos',
		existemCampoDaAeroASerem: 'Existen campos a ser llenados en las aeronaves empleadas.',
		experienciaRecente: 'Experiencia reciente - Últimos 90 días',
		experienciaTotal: 'Experiencia total',
		exportacaoDados: 'Exportación de datos',
		exportarJSON: 'Exportar JSON',
		extrato: 'Extracto',
		extratoDiarioDeBordo: 'Extracto Diario de Bordo',
		fabricante: 'Fabricante',
		fabricanteAtualizado: 'Fabricante Actualizado',
		fabricanteInserido: 'Fabricante Añadido',
		faltaPagar: 'Falta pagar',
		farol: 'Faro',
		fatorContribuinte: 'Factor contribuyente',
		fatura: 'FATURA',
		favorPreencherCamposEmVermelho: 'Por favor llene el (los) campo (s) en rojo.',
		fechaExercicio: 'CERRAR EJERCICIO',
		fechado: 'Cerrado',
		fechar: 'Cerrar',
		fecharDadosDaAeronave: 'Cerrar datos de la aeronave',
		fecharOrdemDeMissao: 'Cerrar el orden de misión',
		fem: 'Femenino',
		fichaCadastralFuncional: 'Ficha de Registro Funcional',
		figado: 'Hígado',
		filtrar: 'Filtrar',
		filtro: 'Filtros',
		fim: 'Fin',
		final: 'Final',
		finalidade: 'propósito',
		finalizadoPor: 'Finalizado por:',
		finalizar: 'Final',
		finalizarTracho: 'Finalizar Tramo',
		foiAtivado: 'Se ha activado',
		foiGeradoUmCodigo: 'Se ha generado una orden de misión con código',
		forcarAssinarTermo: 'Forzar firmar término?',
		forma: 'Pago',
		formaDePagamento: 'Forma de pago',
		fornecedor: 'Proveedor',
		fornecedorCombustivel: 'Suministro de Combustible',
		foto: 'Fotografía',
		fragil: 'Frágil',
		frequencia: 'Frecuencia',
		funcao: 'función',
		funcaoComoTripulante: 'Función como Tripulante',
		funcaoNaEmpresa: 'Función na Empresa',
		funcoes: 'Roles',
		fusoHorario: 'Huso Horario',
		galao: 'Galón',
		gancho: 'Gancho',
		gerais: 'General',
		geral: 'General',
		gerando: 'Generando',
		gerandoDespacho: 'Generando despacho de la semana',
		gerandoRelatorio: 'Generando Informe',
		gerandoRelatorioDemorar: 'Generando Informe(esto puede llevar un tiempo)',
		gerar: 'Generar',
		gerarDespacho: 'Generar despacho',
		gerarDespachoAvulso: 'Generar pedido separado',
		gerarDespachoSemana: 'Generar despacho de la semana',
		gerarDiarioBordo: 'Generar libro de registro',
		gerarExcel: 'Generar Excel',
		gerarMapa: 'Generar Mapa',
		gerarOrdem: 'Generar Orden',
		gerarOrdemDeServico: 'Generar orden de servicio?',
		gerarOrdemMissao: 'Generar Orden de Misión',
		gerarOrdemServico: 'Generar orden de servicio',
		gerarPrevencao: 'Generar Prevención',
		gerarProgramacaoDeVoo: 'Generar horario de vuelos',
		gerarProgramacaoVoo: 'generar horario',
		gerarRelatorio: 'Generar Informe',
		gerenciamentoDeRisco: 'Gestión de riesgos',
		gerenciamentoDeRiscoRecomendacao: 'Recomendación de Gestión de Riesgos',
		gerenciamentoTrecho: 'Gestión de Tramo',
		gerenciamentoVoo: 'Gestión de Vuelo',
		gestaoAbastecimento: 'Administración de proviciones',
		gestaoDe: 'Gestión de',
		gestaoDeContratos: 'Gestión de contratos',
		gestaoDeMalha: 'Gestón de malla',
		gestaoInterna: 'Gestión Interna',
		gestaoLayer: 'Gestión de Capas',
		graficos: 'Gráficos',
		grau: 'GRADO',
		grauDeRelacionamento: 'Grado de Relación',
		graus: 'Grados',
		grupo: 'Grupo',
		grupoDePassageiro: 'Grupo de Pasajeros',
		grupoDePassageiroSalvoComSucesso: 'Grupo de Pasajeros guardado correctamente.',
		grupoDePassageiros: 'Grupo de Pasajeros',
		grupoDePassageirosAtualizadoComSucesso: 'Grupo de pasajeros actualizado con éxito.',
		grupoDePassageirosExcluidoComSucesso: 'Grupo de pasajeros eliminado correctamente',
		grupoDePassageirosSalvoComSucesso: 'Grupo de Pasajeros guardado correctamente.',
		grupos: 'Grupos',
		guarnicao: 'Guarnición',
		guincho: 'Cabrestante',
		hAssinatura: 'Firma',
		hNotificacao: 'Notificaciones',
		haCargaASerTransportada: '¿Hay carga a ser transportada?',
		haContextoOperativo: '¿Hay contexto operativo?',
		haNecessidadeDeAbastecimento: '¿Hay necesidad de reabastecimiento?',
		haNecessidadeDeAlmoco: 'Almuerzo',
		haNecessidadeDeCafeManha: 'Desayuno',
		haNecessidadeDeDiarias: '¿Hay necesidad de empeño de diarias?',
		haNecessidadeDeJantar: 'Cena',
		haPassageiros: '¿Hay Pasajeros?',
		haResalvasNaSituacao: '¿Hay salvedades en la situación?',
		habilitacao: 'Habilitación',
		habilitado: 'habilitado',
		habilitarContrato: 'Habilitar contrato',
		habilitarContratoConfirmacao: '¿Realmente desea habilitar este contrato?',
		habilitarInspecao: 'Habilitar inspección',
		haviamCargasPerigosas: '¿Hubo cargas peligrosas?',
		helicopteros: 'Helicópteros',
		historico: 'Historia',
		historicoAcesso: 'Historial de Acceso',
		historicoAtualizacoesDocumento: 'Historial de actualización de los documentos',
		historicoDoEmpenho: 'Historial de compromisos',
		historicoSistema: 'Historial del sistema',
		historicoVoo: 'Historico del',
		homeHora: 'Hombre/Hora',
		hora: 'Hora',
		horario: 'schedule',
		horarioApresentacaoTripulacao: 'Horario de presentación de la tripulación',
		horarioMaisComum: 'Horario más común',
		horarioPrevisto: 'Hora prevista',
		horariosMaisComuns: 'Horarios más comunes',
		horas: 'Horas',
		horasAcionamentoCorte: 'Horas de Activación de Corte',
		horasCelulaProximaInspecao: 'Horas Célula Próx. Inspección',
		horasDeCelulaParaAProxima: 'Horas de celda previstas para la próxima intervención',
		horasDeUtilizacao: 'Horas de uso',
		horasDeVooApoio: 'Horas de vuelo en apoyo',
		horasDecolagemPouso: 'Horas de Despegue a Aterrizaje',
		horasDisponivel: 'Horas disponibles',
		horasMotor: 'Horas de motor',
		horasMotorInformativo: 'Referido a las horas de motor computadas en el momento de cumplimentar el Libro de Bitácora. El monto será informado solo después de completar el formulario',
		horasOvnAntesDb: 'Gafas de visión nocturna horas antes de completar el primer libro de registro',
		horasPilotoComandoInstrucao: 'Las horas de piloto al mando también incluyen horas como piloto en formación',
		horasTotais: 'El tiempo total',
		horasTotaisAcionamentoCorte: 'Total de horas conducidas al corte',
		horasTotaisDecolagemPouso: 'Horas totales de despegue a aterrizaje',
		horasUsoDecimal: 'Horas de uso (decimales)',
		horasVoadas: 'Horas de Vuelo',
		horasVoadasAbreviacao: 'HV',
		horasVoo: 'Horas de vuelo',
		horasVooTripulacao: 'Horas de Vuelo Tripulación',
		horasVooUsuarioOvn: 'Horas de vuelo con gafas de visión nocturna',
		horimetro: 'Horímetro',
		horimetroFinal: 'Hor. Final',
		horimetroFinalCelula: 'Hor. Final Célula',
		horimetroInicial: 'Hor. Inicial',
		horimetroInicialCelula: 'Hor. Inicio Célula',
		horimetroInicialMotor: 'Horímetro final del motor',
		horimetroInicialOvn: 'Horas de uso de las gafas de visíon nocturna',
		houveAcionamentoDosOrgaos: '¿Hubo acción de los componentes externos del ',
		houveAlijamento: '¿Hubo una emergencia o un vertido involuntario de artículos peligrosos?',
		houveCargaTransportada: '¿Ha habido carga transportada?',
		houveUmErroAoTentarAcessarOSeguinteEnderecoURL: 'Hubo un error al intentar acceder a la siguiente dirección URL',
		houveUmErroAoTentarSalvar: 'Hubo un error al intentar guardar',
		icone: 'Icono',
		id: 'Id',
		idadeAparente: 'Edad Aparente',
		ifrSimulado: 'IFR simulado',
		imagem: 'Imagen',
		imagensCadastradas: 'Imágenes registradas',
		importar: 'Importar',
		importarLayer: 'Importar capa',
		imprimir: 'Imprimir',
		imprimirEtiqueta: 'Imprimir la Etiqueta',
		imprimirPDF: 'Imprimir el PDF',
		imprimirRequisicao: 'Solicitud de impresión',
		inativo: 'Inactivo',
		incluir: 'Incluir',
		incluirLer: 'Incluir + Leer',
		inclusao: 'Inclusión',
		indeterminada: 'Indeterminado',
		indicador: 'Indicator',
		indicadorAno: 'Indicador anual',
		indicadorMes: 'Indicador Mes',
		indiceDocumento: 'Índice por Tipo Documento',
		indiceNomeDocumento: 'Índice de documentos',
		indicePorDocumento: 'Índice por nombre',
		indisponibilidadeAeronave: 'Indisponibilidade de aeronave',
		indisponibilidadeEfetivo: 'Indisponibilidad de efectivo',
		indisponibilizarAeronave: 'Indisponibilizar Aeronave',
		indisponivel: 'Indisponible',
		info: 'Información',
		infoHorasOvn: 'Rellene este campo con el total de horas de vuelo que ya ha realizado utilizando las gafas de visión nocturna. Después de completar esto, el sistema agregará automáticamente este valor inicial a las horas de vuelo en el libro de registro',
		infoOrdemDeMissao: 'Misión Solicitar Información',
		informacaovoo: 'Información de vuelo',
		inicial: 'Inicial',
		inicio: 'Inicio',
		inicioDaOrdem: 'Inicio de la orden',
		inicioOrdem: 'Início da Ordem',
		inpecoesAssinadas: 'Inspección(es) firmada(s).',
		inscricao: 'Inscripción',
		inseridoManualmentePor: 'Inserido manualmente por',
		inseridoPor: 'Inserido por:',
		inspecao: 'Inspección',
		inspecaoAdicionadaComSucesso: 'Inspección agregada con éxito',
		inspecaoAtiva: 'Inspección Activa',
		inspecaoDesativada: 'Inspección deshabilitada',
		inspecaoExcluidaComSucesso: 'Inspección eliminada correctamente',
		inspecoes: 'Inspecciones',
		inspetorResponsavel: 'Inspector Responsable',
		instrucao: 'Instrucción',
		instrumentos: 'Instrumentos',
		instrutor: 'Entrenador',
		instrutorVoo: 'Instructor de Vuelo',
		instruçãoDemissao: 'MISSION INSTRUCCIÓN',
		interacaoSalva: 'Interacción guardada',
		intervalo: 'Intervalo',
		intervaloServico: 'Intervalo de Servicio',
		inverter: 'Reverso',
		irParaO: 'IR PARA EL',
		irParaOrdemDeMissao: 'Ir a la orden de misión',
		irParaOrdemServico: 'Para ir a trabajar',
		itemAtualizado: 'Elemento actualizado',
		itemJaAdicionado: 'Elemento ya agregado',
		itensComOEstadoDefeituosoOuDescarteNaoEstaoDisponiveisParaEntrega: 'Los artículos DEFECTUOSOS o DESECHADOS no están disponibles para entrega',
		itensIntercambiaveis: 'Elementos intercambiables',
		itensParaAeronave: 'Artículos de aviones',
		jaExiste: 'Ya existe.',
		jantar: 'Cena',
		jivochat: 'Jivochat',
		juntadoTrechos: 'Juntando Tramos',
		justificativa: 'Justificación',
		justificativaInspecao: 'esta inspección se requiere una justificación',
		kitComissaria: 'Kit de Comisaría',
		kmAtual: 'Km Actual',
		kmVoado: 'Km Volados',
		largura: 'Ancho',
		lat: 'lat',
		latInicio: 'Lat Start',
		latitude: 'Latitud',
		latitudeFinal: 'Latitud Final',
		latitudeInicial: 'Latitud Inicial',
		lavagemCompressor: 'Lavado de compresores',
		layer: 'Capa',
		layerAtualizadoSucesso: '¡Capa actualizada con éxito!',
		layerCadastradoSucesso: '¡Capa registrada con éxito!',
		layerExcluidoSucesso: '¡Capa eliminada correctamente!',
		leiaAOrdem: 'Lea su orden y al final haga clic en "ACTUALIZAR ORDEN".',
		leiaQRCode: 'Lea el QR Code a través del Followair en su teléfono.',
		leiaSuaSolicitacao: 'Lea su solicitud y al final haga clic en "ENVIAR SOLICITUD".',
		leitores: 'Lectores',
		leituraConfirmada: 'Lectura Confirmada',
		leituraExcluida: 'Lectura Obligatoria eliminada.',
		leituraObrigatoria: 'Lectura Obligatoria',
		leituraObrigatoriaUsuario: 'Lectura obligatória para el usuario actual',
		ler: 'Leer',
		liberadoParaConhecimentoGeral: 'Publicado para conocimientos generales',
		libras: 'Libras',
		licenca: 'Licencia',
		licencaExcluida: 'Licencia eliminada',
		licencasHabilitacoesRegistros: 'Licencias, calificaciones y registros',
		lido: 'Leído',
		lidoPor: 'Leído por',
		limitesContratuais: 'Límites del contrato',
		limpaTudas: 'Borrar todas',
		limpar: 'Limpar',
		linkAPP: 'Aplicación de enlace',
		linkBD: 'Enlace de base de datos',
		linkTrello: 'Enlace a Trello',
		linkWS: 'Enlace WS',
		links: 'Enlaces',
		liquida: 'Líquida',
		lista: 'lista',
		listaContratosNaoOcultos: 'Esta lista se refiere a contratos no ocultos',
		listaContratosOcultos: 'Essa lista se refiere a contratos ocultos',
		listaDePerfis: 'Lista de Perfiles',
		listarNovosUsuarios: 'Listar Nuevos Usuarios',
		litros: 'Litros',
		lng: 'lng',
		local: 'Lugar',
		localDeNascimento: 'Lugar de Nacimiento',
		localisacaoPorao: 'Ubicación del sótano',
		localizacao: 'Ubicación',
		logAcessos: 'Registro de acceso',
		logProcessamento: 'Registro de Procesamiento',
		login: 'Iniciar sesión',
		loginAs: 'Inicio de sesión realizado en',
		loginsHoje: 'Inicios de sesión para hoy',
		logitudeFinal: 'Longitud Final',
		logitudeInicial: 'Longitud Inicial',
		logo: 'Logotipo del cliente',
		logradouro: 'Dirección',
		longInicio: 'Inicio largo',
		longitude: 'Longitud',
		lotacao: 'Capacidad',
		lote: 'Lote',
		maiorValor: 'Mayor que el valor.',
		maisDeumDespacho: 'Encontramos más de un despacho para esa aeronave, seleccione qué despacho ese vuelo se refiere.',
		maisInformacoes: 'Mas informaciones',
		malha: 'Malla',
		malhaAnual: 'Malla anual',
		malhaSemanal: 'Malla semanal',
		malhaVoo: 'malla de vuelo',
		manualOnline: 'Manual en Linea',
		manutencao: 'Mantenimiento',
		manutencaoAeronave: 'Mantenimiento de aeronave',
		manutencaoCiencia: 'Modelo de mantenimiento en la ciencia',
		manutencaoDeuParecer: 'Tiene el parecer del mantenimiento',
		manutencaoNaoDeuParecer: 'El mantenimiento no ha dador',
		manutencoes: 'Mantenimiento',
		mapa: 'Mapa',
		marcaDagua: 'Marca de agua',
		marcaOuModelo: 'Marca / Modelo',
		marcadores: 'Markers',
		marcarTodos: 'Seleccionar todo',
		margemTelaLogin: 'Margen de la pantalla de inicio de sesión en píxeles',
		marqueOsTrechosQueACargaIra: ' Marcar los tramos que recorrerá el pasajero',
		marqueOsTrechosQueOPassageiroIra: 'Elija los tramos que viajará el pasajero:',
		masc: 'Masculino',
		materiaEncerrada: 'Materia cerrada por',
		materias: 'Materias',
		matricula: 'Matrícula',
		matriculado: 'Matriculado',
		maximo: 'Máximo',
		mecanico: 'Mecánico',
		mecanicoResponsavel: 'Mecánico Responsable',
		media: 'Promedio',
		mediaManual: 'Promedio manual',
		medicao: 'Medición',
		mensagem: 'Mensaje',
		menuMissao: 'Misión',
		mes: 'Mes',
		mesAtual: 'Més Actual',
		meses: 'Meses',
		mesesDias: 'Meses y Días',
		mesmoDbMovimentacoes: 'Estos libros de registro a continuación se encontraron para este número EC y este avión. el libro de registro referente al movimiento es Seleccionar',
		mesmoMovimentacoesDb: 'Estos movimientos de combustible a continuación se encontraron para este número EC y este avión. Seleccione el movimiento de combustible para este libro de registro',
		messagemInputError: 'Valor no Válido!',
		meta: 'Meta',
		metaAno: 'Meta Anual',
		metaHoras: 'Meta Horas',
		metaIndicadores: 'Meta e indicadores',
		metaMes: 'Meta Mes',
		metricas: 'Métricas',
		milhas: 'Milhas',
		milhasNauticas: 'Milhas Náuticas',
		minutos: 'Minutos',
		missaoESigilosa: '¿Es la misión confidencial?',
		modalErroElementoJaInserido: 'El elemento ya ha sido insertado.',
		modelo: 'Modelo',
		modeloAtualizado: 'Modelo Actualizado',
		modeloDoMapa: 'Modelo del Mapa',
		modeloInserido: 'Modelo Añadido',
		modelos: 'Modelos',
		modelosAtualizados: 'Modelos actualizados',
		modulo: 'Seleccione el módulo que desea acceder',
		modulos: 'Módulos',
		monitora: 'Monitora',
		monitoramento: 'Monitoreo',
		mostrarDetalhes: 'Mostrar detalles',
		mostrarItens: 'Mostrar elementos',
		motivacao: 'Motivación',
		motivo: 'Razón',
		motorAdicionado: 'Motor Añadido',
		motorAtualizado: 'Motor Actualizado',
		motorEHorario: 'Motor y Horario',
		movimentacaoCombustivel: 'Manejo de combustible',
		movimentacaoCombustivelEntreUnidades: 'Movimiento de Combustible entre Unidades',
		movimentacaoCombustivelEntreUnidadesSucesso: 'Movimiento de Combustible entre Unidades Guardado con Éxito',
		movimentacaoDeCombustivelExcluidaComSucesso: 'Movimiento de combustible eliminado con éxito',
		msgPagamentoMaiorPagamento: 'Usted está agregando un valor mayor que la compra.',
		mudancaFuncao: 'Cambio de Función',
		mudarMoeda: 'Cambiar la moneda',
		multicamadasMapa: 'Multicapa en el mapa',
		municipio: 'Ciudad',
		nOrdem: 'N Orden',
		nSolicitacao: 'Nro. de solicitud',
		nacionalidade: 'Nacionalidad',
		nao: 'No',
		naoAprovado: 'No aprobado',
		naoAssinados: 'No firmados',
		naoCalculado: 'No calculado',
		naoDefinido: 'No definido',
		naoDocumento: 'No hay ningún documento disponible como archivo adjunto',
		naoEPossivelColocarUmValorQueEstaAbaixoDoTotalDeProdutosServicos: 'No es posible colocar un valor por debajo del total de productos/servicios',
		naoEPossivelEscolherUmaQuantidadeMaiorQueADisponivelNoEstoque: 'No es posible elegir una cantidad superior a la disponible en stock',
		naoEPossivelRemoverUmEmpenhoQueHaProdutosServicosVinculados: 'No es posible eliminar un compromiso de que hay productos/servicios vinculados',
		naoEncontramosSuaAero: 'No encontramos esa aeronave dentro de la orden de misión, si quería importar los datos de la aeronave de la orden de misión, basta con hacer clic en el modelo abajo.',
		naoExecutado: 'Sin ejecutar',
		naoExisteDespachoAvulso: 'No se encontró un solo horario de vuelo',
		naoExisteFatoresContribuintesParaOObjetoEscolhido: 'No hay factores que contribuyan al objeto elegido',
		naoExisteNenhumParecerParaEsteRelatorio: 'No hay opinión para este informe.',
		naoFoiPossivelAlterarSenha: 'No se pudo cambiar la contraseña.',
		naoFoiPossivelAssinar: 'No se pudo suscribir',
		naoFoiPossivelAssinarOS: 'No se puede firmar la Orden de Servicio',
		naoFoiPossivelCadastrarUsuario: 'No se puede registrar el usuario',
		naoFoiPossivelCancelar: 'No se puede cancelar',
		naoFoiPossivelEncontrarDados: 'No se ha encontrado ningún dato a través de este login.',
		naoFoiPossivelEnviarSuprimentos: 'No se pueden enviar suministros',
		naoFoiPossivelExcluir: 'Incapaz de borrar',
		naoFoiPossivelGerarRelatorio: 'No se pudo Generar Informe',
		naoHaAeronaves: 'No hay aviones',
		naoHaCarga: 'No hay carga',
		naoHaDiariosDeBordo: 'No hay libros de registro abiertos, libros de registro sin firmar',
		naoHaDiscrepancia: 'No hay discrepancias',
		naoHaEmpregoAeronave: 'No hay empleo de aeronave',
		naoHaNenhumaTarefaCadastrada: 'No hay tarea registrada',
		naoHaRoteiro: 'No hay guía',
		naoInformado: 'No informado',
		naoLido: 'No leído',
		naoNecessarioImprimirRelprev: 'No es necesario imprimir RELPREV',
		naoPossivelExcluirUnidadeMedidaSuprimentosLigados: 'No puede eliminar una unidad de medida con suministros adjuntos',
		naoPossuiEntregas: 'Sin entregas',
		naoSaiaDessaTela: 'No salga de esa pantalla, esto interrumpirá el proceso.',
		naoSatisfeito: 'NO SATISFACE',
		naoSelecionouData: 'No ha seleccionado una fecha.',
		naoTemParecerManutencao: 'No tiene el parecer del mantenimiento',
		naoTemParecerOperacoes: 'No tiene el parecer de las operaciones',
		naoTenhoUmAerodromoDefinido: 'No tengo un aeródromo definido.',
		nascer: 'Salida',
		naturalidade: 'Naturalidad',
		natureza: 'Naturaleza',
		naturezaDoVoo: 'Naturaleza del Vuelo',
		naturezas: 'Naturalezas',
		navegacao: 'Navegación',
		necessarioAdicionarPeloMenosUmItemAoPN: 'Necesario agregar al menos un elemento al PN',
		necessarioPeloMenosUmaInspecao: 'Se requiere al menos una inspección para actualizar',
		negativo: 'Negativo',
		nenhumDadoEncontrado: 'Ningún dato encontrado para esa fecha.',
		nenhumDespacho: 'No encontramos ningún despacho para esa aeronave, seleccione uno en la lista o introduzca un despacho.',
		nenhumDespachoParaEssesDias: 'Ninguno Despacho para estos días',
		nenhumDiarioDisponivelParaAssinatura: 'Ningún diario de a bordo disponible para la firma.',
		nenhumHistoricoEncontrado: 'ningún historial encontrado.',
		nenhumMotorAcionado: 'Ningún motor accionado',
		nenhumProdutoFoiAdicionado: 'No se agregaron productos',
		nenhumResultadoFoiEncontrado: 'No se han encontrado resultados',
		nenhumValorRegistrado: 'Ningún valor registrado',
		nenhumVooEncontrado: 'Ningún vuelo fue encontrado.',
		nenhumaAcao: 'Ninguna acción',
		nenhumaAcaoFoiTomadaDiscrepancia: 'Ninguna acción fue tomada para esa discrepancia.',
		nenhumaConversaEncontrada: 'Ninguna conversación encontrada.',
		nenhumaDiscrepanciaAberta: 'Ninguna discrepancia abierta.',
		nenhumaDiscrepanciaEncontrada: 'Ninguna discrepancia encontrada',
		nenhumaDocumentacaoAdicionada: 'Ninguna Documentación agregada',
		nenhumaImagemCadastrada: 'No hay imagen registrada',
		nenhumaInformacaoEncontrada: 'Nenhuma Informação Encontrada',
		nenhumaNotificacao: 'Usted no tiene ninguna notificación',
		nenhumaNotificacaoEncontrada: 'Ninguna notificación encontrada',
		nenhumaOrdemFoiEncontrada: 'No se ha encontrado ninguna solicitud.',
		nenhumaOrdemParaEssesDias: 'Ninguna orden para estos días',
		nenhumaPosicaoEncontrada: 'Ninguna posición encontrada',
		nenhumaRessalvaAdicionada: 'Ninguna Reserva Agregada',
		nenhumaSolicitacaoParaEssesDias: 'Ninguna Solicitud para estos días',
		nice: 'BIEN',
		nivel: 'Nível',
		nivelDeAprendizagem: 'Nivel de Aprendizaje',
		noLlenado: 'NO LLENADO',
		noMes: 'en el mes',
		nome: 'Nombre',
		nomeAdicionado: 'Nombre añadido',
		nomeCompleto: 'Nombre Completo',
		nomeContato: 'Nombre de Contacto',
		nomeDaUnidade: 'Nombre de la Unidad',
		nomeDocumentoJaExistente: 'Este nombre de documento ya existe',
		nomeESobrenomealuno: 'NOMBRE Y ÚLTIMO NOMBRE',
		nomeESobrenomeinstrutor: 'NOMBRE Y APELLIDO DEL INSTRUCTOR',
		nomeModelo: 'Nombre del modelo',
		nomePasta: 'Nombre de carpeta',
		nomeTipoDocumentoJaExistente: 'Este nombre de tipo de documento ya existe',
		nomeTratamento: 'Nombre de tratamiento',
		nomeclaturaComumMercosul: 'Nomenclatura Común del Mercosur',
		nomeclaturaOleoLubrificante: 'Informar las nomenclaturas que se mostrarán en los Libros de Registro si hay control de aceite lubricante',
		nos: 'nudos',
		notaFiscal: 'Nota Fiscal',
		notasDaVersao: 'Notas de lanzamiento',
		notificaTripulacao: 'Notificar a la tripulación ',
		notificacao: 'NOTIFICACIONES',
		notificacaoAtualizada: 'Notificación actualizada',
		notificacaoEncontrada: 'notificaciones encontradas',
		notificacoesEnviadas: 'Notificaciones enviadas',
		notificadoComSucesso: 'Notificado con éxito',
		notificar: 'Notificar',
		noturno: 'Noturno',
		nova: 'Nueva',
		novaAcao: 'Nueva Acción',
		novaCategoria: 'Nueva Categoría',
		novaComunicacao: 'Nueva Comunicación',
		novaDisciplina: 'Nueva Disciplina',
		novaDiscrepancia: 'Nueva Discrepancia',
		novaDocumentacao: 'Nueva Documentacion',
		novaHabilitacao: 'Nueva licencia',
		novaMalha: 'Malla nueva',
		novaSenha: 'Nueva contraseña',
		novo: 'Nuevo',
		novoAcionamento: 'Nuevo Accionamiento',
		novoCapitulo: 'Nuevo Capítulo',
		novoContato: 'Nuevo contacto',
		novoDespacho: 'Nuevo Despacho',
		novoFornecedor: 'Nuevo Proveedor',
		novoKit: 'Nuevo Kit',
		novoLayer: 'Nueva capa',
		novoMotor: 'Nuevo Motor',
		novoRelatorio: 'Nuevo Informe',
		novoSimplificado: 'Nuevo Simplificado',
		novoTrecho: 'Nuevo tramo',
		numAtividade: 'Nro. Actividad',
		numChamada: 'Nro. Llamada',
		numReds: 'Nro. REDS',
		numSiape: 'Número de SIAPE',
		numberMotor: 'Nº Serie del motor',
		numero: 'Número',
		numeroCarne: 'Número de Carne',
		numeroCe: 'Número CE',
		numeroDB: 'Número DB',
		numeroDaFatura: 'Número de factura',
		numeroDaOrdem: 'Número de orden',
		numeroDaProgramacao: 'Número de horario',
		numeroDeCE: 'Número CE',
		numeroDeVoo: 'Número de vuelo',
		numeroDiario: 'Número de Diario',
		numeroDoCe: 'Número de recibo de entrega',
		numeroDoDespacho: 'Nº del despacho',
		numeroDoDiarioDeBordo: 'Número del libro de registro',
		numeroLicenca: 'Número de Licencia',
		numeroOrdemServico: 'Número de orden de servicio',
		numeroPatrimonio: 'Número de Capital',
		numeroPeca: 'Número de Pieza',
		numeroPrevencao: 'Número de la Prevención',
		numeroSolicitacao: 'Número de solicitud',
		numeroTarefa: 'Número de Tareas',
		oCampoDePassaporteEObrigatorioParaUmEstrangeiro: 'El campo del pasaporte es obligatorio para un extranjero',
		oEventoFoiAtualizadoComSucesso: 'El evento se ha actualizado correctamente',
		oEventoFoiCadastradoComSucesso: 'El evento se registró con éxito',
		oHorimetroDeveSerMenorQueOAtual: 'El contador de horas debe ser más pequeño que la corriente',
		oKitDeveConterUmItem: 'El kit debe contener un mínimo de 1 elemento',
		oPrimeiroAssina: 'El tripulante insertado en el primer casillero será el responsable de firmar el Logbook',
		oRelatorioFoiAtualizadoComSucesso: 'El informe se actualizó correctamente',
		oRelatorioFoiSalvoComSucesso: 'El informe se guardó correctamente',
		oTipoDeSolicitacaoFoiAtualizadoComSucesso: 'El tipo de solicitud se actualizó correctamente',
		oTipoDeSolicitacaoFoiExcluidoComSucesso: 'El tipo de solicitud se eliminó correctamente',
		oTipoDeSolicitacaoFoiSalvoComSucesso: 'El tipo de solicitud se guardó correctamente',
		oTrechoEstaAberto: 'El Tramo de <strong>{{INICIO}}</strong>, está abierto y necesita ser llenado.',
		oTrechodeInicioTexto: 'El tramo de inicio <strong>{{TRECHO}}</strong>, del día <strong>{{INICIO}}</strong>, está abierto y necesita ser llenado.',
		oUsuarioPodeAlterarSuasConfigs: 'El usuario puede editar su configuración?',
		objetivosAlcancados: '¿Se ha alcanzado el objetivo?',
		objetivosMissaoAlcancados: '¿Se alcanzaron los objetivos de la misión?',
		objeto: 'Objeto',
		obrig: 'Requerido',
		obrigInstrutorVoo: 'Obligatorio para el instructor de vuelo',
		obrigPilotoComando: 'Obligatorio para el Piloto en Comando',
		obrigacao: 'Obligatorio',
		obrigatorio: 'Campos con * son obligatorios',
		obs: 'Observación',
		observacao: 'Observación',
		observacoes: 'Comentarios',
		observacoesImportante: 'Notas importantes',
		ocorrencias: 'Ocurrencias',
		ocorreuErroTenteNovamente: 'Se produjo un error, inténtalo de nuevo',
		ocultar: 'Esconder',
		ocultarContrato: 'Esconder Contrato',
		ocultarContratoConfirmacao: '¿De verdad quieres ocultar este contrato?',
		ocultarContratoNaoVigente: 'Ocultar contratos vencidos',
		oficina: 'Taller',
		oficio: 'Empleo',
		okParaUso: 'Bien para usar?',
		ola: 'Hola',
		oleoLubrificante: 'Aceite lubricante',
		opcoes: 'Opciones',
		operacao: 'Operación',
		operacional: 'Operacional',
		operacoes: 'Operaciones',
		operacoesDeuParecer: 'Tiene el dictamen de las operaciones',
		operacoesNaoDeuParecer: 'La operación no dio la opinión',
		operador: 'Operador',
		operadorAerotatico: 'Operador Aerotático',
		operadorIndefinido: 'El operador no se ha definido',
		ordemCancelada: 'Orden cancelada',
		ordemDeMissao: 'Orden de Misión',
		ordemDeMissaoSalva: 'Orden de Misión Salva',
		ordemDeServico: 'Orden de Servicio',
		ordemDeServicoConcluida: 'Orden de Servicio Completado',
		ordemDeServicoSalvaComSucesso: 'La orden de servicio guarda con éxito',
		ordemEncerrada: 'Orden cerrada',
		ordemMissao: 'Órden de Misión',
		ordemMissaoPrevencaoQualificada: 'Orden de Misión de Prevención Cualificada',
		ordemMissaoReaberta: 'Ordem de misión reabierta',
		ordemMissaoRetornoExecucao: "Orden de la misión volvió a 'Correr'",
		ordemMissaoRetornoExecucaoErro: "No se puede devolver el orden de la misión a 'Correr'",
		ordemServicoCancelada: 'Orden de servicio cancelada',
		ordemServicoManutencao: 'Orden de Servicio de Mantenimiento',
		ordensDeMissao: 'Órdenes de Misión',
		ordensGeradas: 'Pedidos generados',
		organizacao: 'Organización',
		orgao: 'Órgano',
		orgaoApioadoSalvo: 'Orgón apoyado salvo',
		orgaoApoiado: 'Órgano Apoyado',
		orgaoApoiadoAtualizado: 'Orgánico apoyado actualizado',
		orgaoApoiadoAtualizadoComSucesso: 'Órgano Compatible actualizado con éxito.',
		orgaoApoiadoUnidades: 'Órganos Compatibles - Unidades',
		orgaoOperador: 'Órgano Operador',
		orgaoProprietario: 'Orgánico Propietario',
		orgaoSolicitante: 'Agencia solicitante',
		orgaos: 'Órganos',
		orgaosApoiados: 'Órganos apoyados',
		orgaosApoiadosDesativados: 'Órgano soportado desactivado',
		origem: 'Fuente',
		origemDoVoo: 'Origen del vuelo',
		origemSistema: 'Documento original del sistema',
		osArquivosNãoPodemSerMaiorQue: 'Los archivos no pueden ser más grandes que',
		osTrechosPrecisamSerSeqquencial: 'Los extractos seleccionados deben ser secuenciales.',
		ou: 'O',
		outras: 'Otros',
		outrasClassificacao: 'otros',
		outros: 'Otro',
		pacote: 'Paquete',
		padrao: 'Estándar',
		pagamento: 'PAGO',
		pagamentoDetalhes: 'Pago',
		pagamentoFeitoSucesso: 'Pago agregado con éxito',
		pagamentoNaoEfetuado: 'Ningún pago efectuado.',
		pais: 'Pais',
		pancreas: 'Páncreas',
		para: 'para',
		paraAddObrigatorio: 'Para este nuevo campo es obligatorio.',
		paraAdicionarTarefasVocePrecisaTerPeloMenosUmaInspecao: 'Para agregar tareas, debe tener al menos una inspección',
		paraRemoverEsteGrupoVocePrecisaRemoverTodasTarefasLigadaAEle: 'Para eliminar este grupo, debe eliminar todas las tareas conectadas a él',
		parametro: 'Parámetro',
		parametrosAeronave: 'Parámetros de la Aeronave',
		parcela: 'Parcela',
		parcelas: 'Las parcelas',
		parciais: 'Parcial',
		parcial: 'Parcial',
		parecer: 'Opinion',
		parecerAdicionadoComSucesso: 'Opinión agregada correctamente',
		pareceres: 'Opiniones',
		partida: 'Salida',
		partidas: 'Salidas',
		passageiro: 'Pasajero',
		passageiroAtualizadoComSucesso: 'Passageiro atualizado com sucesso',
		passageiroExcluidoComSucesso: 'Pasajero eliminado con éxito',
		passageiroSalvoComSucesso: 'Pasajero guardado con éxito',
		passageiros: 'Pasajeros',
		passageirosDaAeronave: 'Pasajeros de la aeronave',
		passaporte: 'Pasaporte',
		passouTolerancia: 'Pasó de la tolerancia',
		pedidoCanceladoComSucesso: 'Pedido cancelado con éxito',
		peloMenosUmContato: 'Debe agregar al menos un contacto',
		peloMenosUmTelefone: 'Debe agregar al menos un número de teléfono',
		peloUsuario: 'por el usuario',
		pendentePagamento: 'Pendiente Pago',
		percentualRestante: 'Porcentaje restante',
		percursoASerEfetuado: 'Recorrido a efectuar',
		perfil: 'Perfil',
		perfilDoUsuario: 'Perfil del usuario',
		perfilTripulacao: 'Perfil de la tripulación',
		perfis: 'Perfiles',
		perguntasERespostas: 'Preguntas y respuestas',
		perigosa: 'Peligroso',
		permissaoExcluida: 'Permiso eliminado',
		permissaoNegada: 'Permiso rechazado',
		permiteAlterarOContrato: 'Te permite cambiar el contrato',
		permiteMovimentarOContrato: 'Le permite mover el contrato',
		pernoite: 'Quedarse por la noche',
		peso: 'Peso',
		pesoAprox: 'Peso Aprox.(Kg)',
		pesoPassageiro: 'Peso del pasajero',
		pesoTotal: 'Peso total del equipaje',
		pessoalEnvolvido: 'Personal involucrado',
		pessoasDetidas: 'Personas detenidas',
		pessoasSalvas: 'Personas Salvas',
		piloto: 'Piloto',
		pilotoComando: 'Piloto en el mando',
		pilotoECopiloto: 'Piloto y Copiloto',
		pilotoInstrucao: 'Piloto en Instrucción',
		pilotoResponsavel: 'Piloto Responsable',
		placa: 'Placa',
		planejada: 'Planificado',
		plano: 'Plan',
		planoDeFundo: 'Fondo de Pantalla',
		planoDeFundoAtual: 'Antecedentes actuales',
		planoDeRegistro: 'AVION MATRICULA',
		planoPlem: 'Plan de emergencia aeroportuaria (PLEM)',
		planoPre: 'Plan de respuesta a emergencias de la empresa (PRE)',
		pn: 'PN',
		podeSerAlocado: 'Permiso de Asignación',
		pontos: 'Marcadores',
		pontualOuCondicao: 'Puntual o bajo condición',
		por: 'Puesta',
		porHoraVoada: 'Con alas por hora',
		porQuestoesAlterarSenha: 'Por cuestiones de seguridad es necesario que cambie su contraseña.',
		porcentagem: 'Porcentaje',
		porcentagemConsumidaDoContrato: 'Porcentaje consumido del contrato',
		porcentagemConsumidaDoEmpenho: 'Porcentaje de esfuerzo consumido',
		posGraduacao: 'Pós-Graduação',
		posicao: 'Posición',
		posicaoVoo: 'Posiciones de Vuelo',
		posicoes: 'Posiciones',
		positivo: 'Positivo',
		pouso: 'Aterrizaje',
		pousoPrevisto: 'Aterrizaje planificado',
		pousos: 'Aterrizajes',
		pratica: 'PRÁCTICA',
		prazo: 'Plazo',
		prazoParaExecucao: 'Fecha límite para la ejecución',
		preRequistos: 'Prerrequisitos',
		predefinicoes: 'Plantillas',
		preechaTodasAsInformacoesNecessarias: 'Complete toda la información necesaria',
		preenchaOsDadosDoSolicitante: 'Rellene los datos de la autoridad solicitante.',
		preenchaPeloMenosUmCampo: 'Por favor complete al menos un campo',
		preencher: 'Llenar',
		preenchimentoConcluido: 'Relleno completado',
		preenchimentoMotorHorario: 'El llenado de los 4 campos de Motor y Hora debe hacerse en hora local.',
		preenchimentoPeriodo: 'Preste atención a la cumplimentación de los campos Día, Noche, IFR real, IFR simulado y VFR.',
		prefiroNaoDeclarar: 'No Declare',
		prefixoOuIdentificacao: 'Prefijo/Identificación',
		prefixoOuIdentificacaoDoVeiculo: 'Prefijo / Identificación del vehículo',
		prevencao: 'Prevención',
		prevencaoQualificada: 'Prevención Cualificada',
		prevencaoSalva: 'Prevención Salva',
		preventiva: 'Preventivo',
		previewOrdemMissao: 'Vista previa del orden de la misión',
		previsao: 'Previsión',
		previsaoDeData: 'Fecha Pronóstico',
		previsaoDisponibilidadeDbEletronico: 'Electronic DB Availability Forecast',
		primeiroPilotoComando: '1º Piloto en Mando',
		prioridade: 'Prioridad',
		privilegio: 'Privilegio',
		proa: 'Arco',
		processaVoos: 'Procesos de vuelos',
		processandoManutencao: 'Procesando mantenimiento (esto puede tardar un poco)',
		processarAuditoria: 'Procesamiento de Auditoría',
		processo: 'Proceso',
		processoEmAndamento: 'Proceso en curso de una orden de misión o despacho.',
		produto: 'Producto',
		produtoExcluidoComSucesso: 'Producto eliminado correctamente',
		produtoSalvoComSucesso: 'Producto guardado correctamente',
		produtoServico: 'Product/Service',
		produtoServicoExcluidoComSucesso: 'Product/Service successfully deleted',
		produtoServicoSalvoComSucesso: 'Product/Service has been successfully saved',
		produtos: 'Productos',
		produtosServicos: 'Products/Services',
		produtosServicosVinculados: 'Productos/Servicios vinculados',
		programacaoVoo: 'Programacion de Vuelo',
		provedorSMS: 'Proveedor de SMS',
		proximaInspecao: 'Siguiente intervención',
		proximo: 'Seguiente',
		qtdDias: 'Cantidad de días',
		qtdeASerEntregue: 'Cant. para ser entregado',
		qtdeEmEstoque: 'Cant. en stock',
		qtdeEntregue: 'Cant. Entregado',
		qtdeRecebida: 'Cant. Recibió',
		qtdeSolicitado: 'Cant. Solicitado',
		qualAeronaveVaiSerUtilizada: '¿Qué aeronave se utilizará?',
		qualDirigenteDesseOrgao: '¿Quién es el dirigente de este órgano?',
		qualOMotivo: '¿Cuál es el motivo?',
		qualificacaoCivil: 'Cualificación civil',
		qualificada: 'Cualificada',
		qualquerAeronave: 'Cualquier aeronave',
		quantidade: 'Cantidad',
		quantidadeAtual: 'Cantidad Actual',
		quantidadeDeDias: 'Número de días',
		quantidadeDeLitros: 'Cantidad de Litros',
		quantidadeDeveSerMaiorQueZero: 'La cantidad debe ser mayor que 0',
		quantidadeDeveraSerMaiorQueZero: 'La cantidad debe ser mayor que 0',
		quantidadeDisponivel: 'Cantidad disponible',
		quantidadeEstimadaPassageiros: 'Número estimado de pasajeros',
		quantidadeHorasAcionamentoAoCorte: 'Cantidad Horas (Unidad de corte)',
		quantidadeHorasDecolagemAoPouso: 'Cantidad Horas (Aterrizaje Despegue)',
		quantidadeMinima: 'Cantidad Mínima',
		quantidadeMissao: 'Misión de cantidad',
		quantidadeTransferir: 'La cantidad a transferir',
		quantidadeTransferirMovimentacaoCombustivel: 'La cantidad a transferir (l)',
		quantitativo: 'Cuantitativo',
		quantos: '¿Cuántas?',
		quantosItens: '¿Cuántos elementos?',
		quemEOOperador: '¿Quién es el operador de esta solicitud?',
		quilometros: 'Kilómetros',
		radial: 'Radial(grados)',
		radio: 'Radio',
		rastreado: 'Rastreado',
		rastreadoresAtivos: 'Rastreadores activos',
		razaoLatitude: 'Relación de latitud',
		razaoLongitude: 'Razón de longitud',
		razaoSocial: 'Razón Social',
		rbacTolerancia: 'Se permite el funcionamiento normal relativo a una licencia vencida hace menos de 30 (treinta) días. Se prohíbe la operación normal relacionada con una licencia vencida hace más de 30 (treinta) días, en cualquier situación.',
		reabastecimento: 'Reposición',
		reabertura: 'Reabriendo',
		reabrindo: 'Reapertura',
		reabrir: 'ABRIR',
		reabrirDespacho: '¿Desea volver a abrir este despacho?',
		reabrirOrdem: 'Reabrir Orden',
		realprevTelaLogin: 'Pantalla de inicio de sesión de Realprev',
		reativadoComSucesso: 'Reactivado con éxito',
		reativar: 'Reactivar',
		receber: 'Recibir',
		receberSuprimentos: 'Recibir suministros',
		recebido: 'Recibió',
		recebidoPor: 'Recebido por',
		recomendacao: 'Recomendación',
		recomendacoes: 'Recomendaciones',
		refOrigem: 'Ref Origen',
		referencias: 'Referencias',
		registro: 'Registro',
		registroAbastecimento: 'Registro de suministro',
		registroHFDM: 'FDM',
		registroNome: 'INSCRIPCIÓN - NOMBRE',
		registrosPrincipaisTabelas: 'Registros en tablas principales',
		regua: 'regla',
		reguaDigital: 'Regla digital',
		regulamento: 'Reglamento',
		regulamentoAtualizado: 'Reglamento actualizado',
		regulamentoSalvo: 'Regulamento salvo',
		regular: 'REGULAR',
		relacao: 'Relación',
		relator: 'Reportero',
		relatorio: 'Informe',
		relatorioAbastecimento: 'Relatório Abastecimento',
		relatorioAlocacao: 'Informe de Asignación',
		relatorioAviacaoCivil: 'Informe de aviación civil',
		relatorioDiarios: 'Informe diario',
		relatorioEquipamentoOvn: 'Informe de gafas de visión nocturna',
		relatorioHorasDeVoo: 'Informe de Horas de Vuelo',
		relatorioHorasVoadas: 'Informe de Horas Voladoras',
		relatorioIndicadorEfetividade: 'Informe de Indicador de Efectividad',
		relatorioMetaHorasVoadas: 'Informe de las Horas Voladas',
		relatorioMovimentacaoCombustivel: 'Relación de movimiento de combustión',
		relatorioOVN: 'Informe GVN',
		relatorioPerfil: 'Informe de perfil',
		relatorioPerfilUsuario: 'Informe Perfil y Usuario',
		relatorioPrestacaoDeContas: 'Informe de Cuentas de Cuentas',
		relatorioProdutividade: 'Informe de productividad',
		relatorioSinteticoDeProdutividade: 'Encuesta de productividad',
		relevancia: 'Relevancia',
		removeTrechoVoltaHorimetro: 'Quita el tramo y vuelve el horímetro',
		remover: 'Eliminar',
		removerAeronave: 'Quitar Aeronave',
		removidoSucesso: 'Eliminado con éxito',
		renovacao: 'Renovación',
		requisicao: 'Solicitud',
		requisitos: 'Requisitos',
		responavelMovimentacao: 'Responsable de la manipulación',
		responsavel: 'Responsable',
		responsavelCarga: 'Responsable de la carga',
		responsavelExecucao: 'Responsable de la ejecución',
		responsavelMovimentacao: 'Responsable del manejo',
		responsavelOS: 'Responsable de la orden de servicio',
		responsavelPelaAprovacao: 'Responsable por la aprobación para retorno al servicio',
		responsavelPelaCriacaoDaOrdem: 'Responável pela Confecção da Ordem de Missão',
		responsavelPelaExecucao: 'Responsable de la ejecución',
		responsavelPeloRetorno: 'Responsable del retorno',
		responsavelTecnico: 'Responsable técnico',
		ressalvas: 'Reservas',
		resultados: 'Resultados',
		resultadosObtidos: 'Resultados obtenidos',
		resumoDaOrdemDeMissao: 'Resumo da Ordem De Missão',
		resumoDaSolicitacao: 'Resumen de la solicitud',
		retornarExecucao: "Volver a 'Corriendo'",
		retirada: 'Retirada',
		retiradoEm: 'Eetirado el:',
		retrair: 'Retraer',
		revalidacao: 'Revalidación',
		revisar: 'Revisión',
		rim: 'Riñón',
		roteiro: 'Guión',
		rua: 'Calle',
		ruaSemNome: 'Calle sin nombre',
		sair: 'Salir',
		sairTelaCheia: 'Salir Pantalla Completa',
		salvando: 'Guardando',
		salvandoGerandoRastreamento: 'Guardar y generar seguimiento',
		salvandoSolicitacaoAvulsa: 'Guardar solicitud perdida',
		salvar: 'Guardar',
		salvarAlteracoes: 'Guardar ediciones',
		salvarE: 'Salvar es',
		salvarImagem: 'Guardar imagen',
		salvarNovoPadrao: 'Guardar nuevo patrón',
		salvarPagamento: 'SALVAR',
		salvarTermo: 'Quardar Término',
		salvarTrechos: 'Guardar Tramos',
		salvo: 'Salvo',
		salvoComSucesso: 'Guardado exitosamente',
		satelite: 'Satélite',
		saudeESanitarias: 'de salud y sanitario',
		se: 'Si',
		seOErroPersistirPorFavorEntreEmContatoConosco: 'Si el error persiste, contáctanos',
		secao: 'Sección',
		secaoAtualizada: 'Sección actualizada',
		secaoExpirada: 'Sección expirada',
		segundoPilotoComando: '2º Piloto en Mando',
		segurancaPublica: 'de seguridad pública',
		segurancaRelativa: 'de seguridad relacionados con actos de injerencia ilícita contra la aviación civil',
		seguro: 'Seguro',
		sejaBemVindo: 'Seja bem-vindo ao',
		selecionarDespacho: 'Seleccione una Orden',
		selecionarItens: 'Seleccionar articulos',
		selecionarMalha: 'seleccionar malla',
		selecionarSemana: 'Seleccione Semana',
		selecionarUmDiario: 'Seleccione el libro de registro a continuación.',
		selecione: 'Seleccionar',
		selecioneAeronave: 'Seleccione una Aeronave',
		selecioneAoMenosUmAcesso: 'Seleccione al menos un acceso al tipo de documento.',
		selecioneAoMenosUmLeitor: 'Seleccione al menos un lector para el documento',
		selecioneAsCargasTransportadas: 'Seleccionar las cargas transportadas',
		selecioneInspecaoAbaixo: 'Seleccione una inspección abajo',
		selecioneOAcesso: 'Seleccione lo acesso',
		selecioneOTipo: 'Seleccione el tipo',
		selecioneOUsuario: 'Seleccione el usuario',
		selecioneOrdemMissaoAbaixo: 'Seleccione la orden a la siguiente misión.',
		selecioneOrdemMissaoPrevencaoAbaixo: 'Seleccione la orden de misión de prevención que se describe a continuación.',
		selecioneOrdemMissaoPrevencaoQualificada: 'Seleccione una orden de misión de prevención cualificada',
		selecioneOsPassageirosTrecho: 'Seleccione los pasajeros que volaron ese tramo',
		selecioneOsTrechosAgrupados: 'Seleccione los tramos que se van a agrupar a continuación.',
		selecioneParaExibir: 'Seleccione un elemento para abrir la configuración.',
		selecioneParaExportar: 'Seleccionar el formato para la exportación de datos',
		selecioneSeDesejaNotificar: 'Seleccione si deseas notificar',
		selecioneUmContratoAtivo: 'Seleccione un contrato activo',
		selecioneUmContratoOculto: 'Seleccione un contrato oculto',
		selecioneUmContratoOcultoParaHabilitar: 'Seleccione un contrato oculto para permitir',
		selecioneUmEmpenho: 'Seleccione un esfuerzo',
		selecioneUmaAero: 'Seleccione una aeronave para comenzar.',
		selecioneUmaAeronave: 'Seleccione una aeronave',
		selecioneUmaMoeda: 'Seleccione una moneda',
		selecioneUmaOrdemDeMissao: 'Seleccione una orden de misión',
		sem: 'Sin',
		semDataInstalacao: 'Aún no se han instalado los PN con fecha 00/00/0000',
		semMaisConversa: 'sin más conversación.',
		semPassageiros: 'Sin Pasajeros',
		semSolicitacao: 'No hay pedidos',
		semValor: 'Sin valor',
		semVitimas: 'Sin Víctimas',
		senha: 'Contraseña',
		senhaInvalida: 'Contraseña no válida.',
		senhaSpider: 'Contraseña de araña',
		separado: 'Separado(a)',
		seraNecessarioAssinarAlgumaInspecaoParaConfirmarNovasAlteracoesNosDadosDessaOrdemDeServico: 'Deberá firmar una inspección para confirmar los nuevos cambios en los datos de esa orden de trabajo.',
		servicesWS: 'Servicios WS',
		servico: 'Servicio',
		servicos: 'Mantenimiento',
		servicosAExecutar: 'Servicios a ejecutar',
		servicosExecutados: 'Servicios desempeñados',
		sessao: 'Sesión',
		sessaoAtualizada: 'Sesión actualizada',
		sessaoExpirada: 'Sesión expirada',
		setor: 'Sector',
		setorDestino: 'Sector objetivo',
		setorOuOrgaoExterno: 'Sector / Órgano externo',
		sexo: 'Género',
		sgpe: 'Nr do Arquivo SGP-e da pasta digital individual.',
		sigla: 'Acrónimo',
		sim: 'Sí',
		simples: 'Simple',
		simulador: 'SIMULADOR',
		sistemaIntegrado: 'Sistema Integrado',
		sistemasDoCliente: 'Sistemas de clientes',
		situacao: 'Situación',
		sn: 'SN',
		snOvn: 'Número de serie de las gafas de visión nocturna',
		soRecomendacoes: 'Recomendación',
		sobre: 'Sobre',
		socorridos: 'Socorridos',
		solicitaUsoAeronave: 'Solicitud de uso de aeronave',
		solicitacao: 'Solicitud',
		solicitacaoCancelada: 'Solicitud cancelada.',
		solicitacaoCriadaDeUmaOrdemDeServico: 'Solicitud creada a partir de una orden de servicio',
		solicitacaoInserida: 'Solicitud insertada en el sistema.',
		solicitacaoSalva: 'Solicitud Salva',
		solicitacoes: 'Solicitudes',
		solicitacoesItensAvulsas: 'Solicitudes de un solo artículo',
		solicitado: 'Solicitado',
		solicitante: 'Solicitante',
		solicitanteCancelou: 'Solicitante canceló',
		solicitanteDaMissao: 'Solicitante de la Misión',
		solicitar: 'Pedido',
		solicitarItemAvulso: 'Solicitar un solo artículo',
		solo: 'Terreno',
		solteiro: 'Solo(a)',
		somaDiurnoNoturno: 'La suma de los campos "Día" y "Noche" debe ser igual al "Tiempo de vuelo del piloto"',
		somaIfrVfr: 'La suma de los campos "VFR" y "IFR" debe ser igual al "Tiempo de vuelo del piloto"',
		somentePeso: 'Solo peso',
		souPiloto: 'Soy Piloto',
		status: 'Estado',
		statusContrato: 'Estado del contrato',
		statusDaExecucao: 'Estado de ejecución',
		statusDaRecomendacao: 'Estado de la recomendación',
		statusExcluidoComSucesso: '¡Estado eliminado correctamente!',
		statusFoiSalvoComSucesso: '¡El estado se ha guardado correctamente!',
		statusLeitura: 'Status de Lectura',
		statusLicencas: 'Días restantes hasta el vencimiento.',
		suaSecaoExpirou: 'Su sección ha caducado.',
		suaSessaoExpirou: 'Su sesión ha caducado.',
		subEclassificacao: 'Subclasificación y Clasificación',
		subcategoria: 'Subcategoría',
		subclassificacao: 'Subclasificación',
		subclassificacaoAtualizada: 'Subclasificación actualizado',
		subclassificacaoDesativada: 'Subclasificación deshabilitada',
		subclassificacaoExcluida: 'Subclasificación excluida',
		subclassificacaoInstrucao: 'subclasificación de Instrução?',
		subclassificacaoSalva: 'Subclasificación salvo',
		subtitulo: 'Subtítulo',
		suporte: 'Soporte',
		tabela: 'Tabla',
		tamanhoTelaLogin: 'Ancho de la pantalla de inicio de sesión en píxeles',
		tanque: 'Tanque',
		tarefaAdicionada: 'Tarea Agregada',
		tarefaCadastrada: 'Tarea Registrada',
		tarefaRemovidaComSucesso: 'Tarea eliminada correctamente',
		tarefas: 'Tareas',
		tas: 'Tas',
		telaCheia: 'Pantalla Completa',
		telefone: 'Teléfono',
		telefoneCelular: 'Teléfono celular',
		telefoneDeEmergencia: 'Teléfono de emergencia',
		telefoneResidencial: 'Teléfono residencial',
		temUmTermino: 'Tiene un término',
		template: 'Plantilla',
		tempo: 'Tiempo',
		tempoBusca: 'Búsqueda de tempo',
		tempoDePreenchimento: 'Tiempo de llenado',
		tempoDeVoo: 'Tiempo de vuelo',
		tempoEstimado: 'Tiempo estimado',
		tempoEstimadoViaAr: 'ETA vía AÉREA',
		tempoIndisponibilidade: 'Duracíon de la indisponibilidad',
		tempoRestante: 'Tiempo restante',
		tempoSessao: 'Hora de la sesión',
		tempoSobrevoo: 'Tiempo de Sobrevuelo',
		tempoTotal: 'Tiempo total',
		tempoTotalPiloto: 'Tiempo total del piloto:',
		tempoVooMuitoGrande: 'Tiempo de vuelo muy grande',
		tentativas: 'Intentos',
		teorico: 'TEÓRICO',
		termino: 'Final',
		terminoOrdem: 'Terminación de la orden',
		termoAtualizado: 'Término Actualizado',
		termoDeUso: 'Término de Uso',
		termoDescentralizacaoCredito: 'Plazo Descentralización Crédito',
		texto: 'Texto',
		textoDiaDiscrepancia: 'tiene un mayor número de casos ocurriendo en el',
		textoDigiteSeuLogin: 'Introduzca su login que vamos a encontrar la mejor forma de establecer una nueva contraseña.',
		textoHorarioDiscrepancia: 'en un horario próximo a las',
		textoLogin: 'Texto en la pantalla de inicio de sesión',
		textoModificarSenha: 'Para modificar su contraseña actual, introduzca la nueva contraseña en el campo siguiente.',
		textoSenhaAlteradaSucesso: 'Su contraseña ha cambiado con éxito!',
		ticket: 'Entrada',
		tipo: 'Tipo',
		tipoAcionamento: 'Tipo de Accionamiento',
		tipoAplicacao: 'Tipo de aplicación',
		tipoArmazenamentoExcluido: 'Tipo de almacenamiento eliminado correctamente',
		tipoCombustivel: 'Tipo de combustible',
		tipoContrato: 'Tipo de Contrato',
		tipoContratoExcluidoComSucesso: '¡Tipo de contrato eliminado correctamente!',
		tipoContratoFoiSalvoComSucesso: '¡El tipo de contrato se ha guardado correctamente!',
		tipoControle: 'Tipo de control',
		tipoDeAmazenamentoSalvoComSucesso: 'Tipo De almacenamiento guardado exitosamente!',
		tipoDeArmazenamento: 'Tipo de Almacenamiento',
		tipoDeCarga: 'Tipo de carga',
		tipoDeLicenca: 'Clase de Licencia',
		tipoDePagamento: 'Tipo de pago',
		tipoDePlano: 'Tipo de plan',
		tipoDeSolicitacao: 'Tipo de solicitud',
		tipoDeUsuario: 'Tipo de usuario',
		tipoDeVoo: 'Tipo de vuelo',
		tipoDespacho: 'Tipo de Despacho',
		tipoDoEvento: 'Tipo de evento',
		tipoDocumento: 'Tipo Documento',
		tipoDocumentoExcluidoComSucesso: 'Tipo documento eliminado con éxito',
		tipoDocumentoSalvoComSucesso: 'Tipo documento guardado con éxito',
		tipoEmbalagemCadastro: 'Tipo de embalaje caducado con éxito',
		tipoMapa: 'Tipo Mapa',
		tipoMissao: 'Tipo de misión',
		tipoMovimentacao: 'Tipo de movimiento',
		tipoOrdemDeMissao: 'Tipo de Orden de Misión',
		tipoOrdemMissaoExcluidoComSucesso: 'Tipo Orden de Misión eliminado correctamente',
		tipoOrdemMissaoSalvoComSucesso: 'El Tipo Orden de Misión se ha guardado correctamente',
		tipoProximaIntervencao: 'Tipo de la próxima intervención',
		tipoTarefa: 'Tipo de tarea',
		tipoUltimaIntervencao: 'Tipo de la última intervención',
		tipoUnidadeArmazenamento: 'Tipo Unidad Almacenamiento',
		tiposDeSolicitacao: 'Tipos de solicitud',
		titulo: 'Para generar el informe, llene los siguientes campos',
		tituloPrimario: 'Título',
		tituloTarefa: 'Título de la Tarea',
		todas: 'Todos',
		todasAsFuncoes: 'Todas las funciones',
		todasDiscrepanciasConcluidas: 'Todas las discrepancias completadas',
		todasInspecoesAssinadaPeloInspetor: 'Todas las inspecciones firmadas por el inspector',
		todasInspecoesAssinadaPeloMecanico: 'Todas las inspecciones firmadas por el mecánico.',
		todasNaturezas: 'Todas las naturalezas',
		todasNturezas: 'Todas Naturalezas',
		todasSeraoExibidas: ' todo se mostrará',
		todos: 'Todos',
		todosGrupos: 'Todos los grupos',
		todosOsDiariosForamAssinados: 'Ok! Todos los Diarios de Bordo de esa aeronave fueron firmados.',
		todosOsTipos: 'Todos los Tipos',
		todosOsTrechos: 'Todos los extractos',
		todosProcessosOrdemMissaoOuDespachoConcluidos: 'Todos los procesos de la orden de misión o de la orden se concluyeron.',
		tolerancia: 'Tolerancia',
		toleranciaDisponivel: 'Tolerancia disponible',
		tooltipDescricaoFatos: 'Descripción de los hechos, indicando necesariamente qué y cómo ocurrió el hecho. Algunos ejemplos de ocurrencia son la muerte de un pasajero en vuelo, una mujer en trabajo de parto, transmisión de un virus, etc.',
		tooltipLocalOcorrencia: 'Lugar de ocurrencia, necesariamente, por el código de localidad o coordenada geográfica si en el suelo y, obligatoriamente por coordenada geográfica, si en vuelo.',
		tooltipQualificacaoCivil: 'Mejor cualificación civil posible de las personas implicadas (nombre completo, documento de identificación utilizado para el embarque, nacionalidad y fecha de nacimiento, entre otros).',
		tooltipReabrirDespacho: 'Reabrir Despacho',
		tornarRecomendacaoDeConhecimentoPublico: 'Hacer pública la recomendación',
		totais: 'Totales',
		total: 'Total',
		totalCapacidadeMaxima: 'Capacidad máxima total',
		totalCiclosAviao: 'Total de Ciclos',
		totalCiclosVoados: 'Total de Ciclos Volados',
		totalDeCiclosNF: 'Total de Ciclos NF',
		totalDeCiclosNG: 'Total de Ciclos NG',
		totalDeCiclosNP: 'Total de Ciclos NP',
		totalDecolagemPouso: 'Despegue total a aterrizaje',
		totalDeGancho: 'Total de Gancho',
		totalDeGuincho: 'Total de Guincho',
		totalDeOcorrencias: 'Total de ocurrencias',
		totalDePartidas: 'Total de Salidas',
		totalDePousos: 'Total de Pisos',
		totalDia: 'Total en el día',
		totalDoTreinamento: 'Total del treinamento',
		totalHorasPiloto: 'Total de Horas (Piloto)',
		totalHorasUtilizacao: 'Horas de uso totales',
		totalHorasVoadas: 'Total de Horas Voladas',
		totalNaoRastreado: 'Total não rastreado',
		totalPago: 'Total Pago',
		totalRastreado: 'Total Rastreado',
		totalvolume: 'Volumen Total',
		trabalho: 'Trabajo',
		transferencia: 'Transferencia',
		transferenciaBase: 'Transferencia de Base',
		transicao: 'Transición',
		trecho: 'Tramo',
		trechoAdicionado: 'Tramos añadido.',
		trechoAgrupadoPor: 'Trecho agrupado por',
		trechoAposData: 'Las secciones solo pueden tener una fecha de activación después de la fecha de corte de la última sección',
		trechoAssinado: 'Tramo firmado',
		trechoDesagrupado: 'Tramo desagrado.',
		trechoExcluido: 'Tramo excluido.',
		trechoJuntado: 'Tramo agrupado.',
		trechosAgrupados: 'Tramos Agrupados',
		trechosQueOPassEstara: 'Extractos que el pasajero estará',
		treinamento: 'Treinamento',
		trigrama: 'Trigrama',
		tripulacao: 'Tripulación',
		trocaEquipamentoAeronave: 'Equipo de avión de intercambio',
		trocaSucesso: 'Intercambio completado con éxito',
		txtNovoTipoHabilitacao: 'Haga clic en "Nueva licencia"',
		ubidadeDeOrgaoApoiadoSalvoComSucesso: 'Unidad de órgano apoyado guardada con éxito',
		ultima: 'Última',
		ultimaData: 'Última fecha',
		ultimaInspecao: 'Última intervención',
		ultimaManutencaoRealizada: 'Se celebra el último mantenimiento',
		ultimo: 'Último',
		ultimoServico: 'Último Service',
		ultimoVoo: 'Último Vuelo',
		ultimos30Dias: 'Últimos 30 días',
		ultimos60Dias: 'Últimos 60 días',
		ultimos90Dias: 'Últimos 90 días',
		umCampoObrigatorio: 'Completa al menos un teléfono',
		umDessesCampoEObrigatorio: 'Uno de estos campos es obligatorio.',
		unidade: 'Unidad',
		unidadeArmazenamento: 'Unidad Almacenamiento',
		unidadeArmazenamentoSalvaComSucesso: 'Unidad de almacenamiento guardada exitosamente',
		unidadeCompra: 'Unidad de compra',
		unidadeContabil: 'Unidad de Contabilidad',
		unidadeDeArmazenamentoDeDestino: 'Unidad de almacenamiento de destino',
		unidadeDeArmazenamentoDeOrigem: 'Unidad de Almacenamiento de Origen',
		unidadeDeConservacao: 'Unidad de Conservación',
		unidadeDestino: 'Unidad de Destino',
		unidadeDoOrgao: 'Unidad de Órgano',
		unidadeDoOrgaoApoiadoExcluidoComSucesso: 'Unidad de órgano apoyado eliminado con éxito',
		unidadeMedida: 'Unidad de Medida',
		unidadeOrcamentaria: 'Unidad de Presupuesto',
		unidadeOrcamentariaExcluida: 'Unidad de presupuesto eliminada',
		unidadeOrcamentariaSalvaComSucesso: 'Unidad de Presupuesto se guardó con éxito',
		unidadeOrgaoApoiado: 'Unidad de Apoyo de Órganos',
		unidadeOrigem: 'Unidad de Origen',
		unidades: 'Unidades',
		url: 'URL',
		userSpider: 'Usuario Araña',
		usoDe: 'Uso de',
		usoDeAereonave: 'Uso de la aeronave',
		usoDeFlir: 'Uso de FLIR',
		usoDeOvn: 'Uso de OVN',
		usuario: 'Usuario',
		usuarioDesativado: 'Usuario Deshabilitado',
		usuarioSemLicenca: 'Usuario no tiene ninguna Licencia',
		usuarios: 'Usuarios',
		usuariosAtivos: 'Usuarios Activos',
		usuariosAtivosInativos: 'Usuarios Activos / Deshabilitados',
		usuariosDesativados: 'Usuarios Deshabilitados',
		usuariosSimultaneos: 'Usuarios concurrentes',
		utilizaSigiloOM: 'Usa el secreto en la orden de la misión',
		utilizaTrigrama: 'Utiliza Trigram',
		validade: 'Duracion',
		validandoIntegridadeDoDiarioDeBordo: 'Validación de la integridad del libro de registro',
		validandoSenha: 'Validando contraseña',
		validos: 'Válido',
		valor: 'valor',
		valorDoContrato: 'Valor del contrato',
		valorDoLitro: 'Valor del Litro',
		valorDoPagamento: 'Valor Pago',
		valorEmpenhado: 'Valor Esforzado',
		valorHoraTreinamentoPrático: 'valor del treinamento práctico',
		valorMaiorQueTempoPiloto: 'Valor mayor que el tiempo del piloto',
		valorNaoPermitidoPorUltrapassarOValorContratado: 'Cantidad no permitida por exceder el valor contratado',
		valorNaoPermitidoPorUltrapassarOValorEmpenhado: 'Cantidad no permitida por exceder la cantidad de esfuerzo',
		valorNumericoInvalido: 'Valor numérico no válido.',
		valorProdutoServico: 'Product/Service Value',
		valorRecuperado: 'Valor Recuperado',
		valorTempoVoo: 'Valor de la hora de vuelo',
		valorTotal: 'Valor Total',
		valorTotalEmProdutosServicos: 'Importe total en productos/servicios',
		valorTreinamentoTeorico: 'valor del treinamento teórico',
		valorUnitario: 'Valor Unitario',
		valordaMatricula: 'valor de la matrícula',
		valoresAtivos: 'Valores activos',
		valoresDoContrato: 'Valores del contrato',
		varIndMeta: 'var % ind/meta',
		variacoes: 'Variaciones',
		vcTemQueDigitarSenha: 'Usted tiene que introducir su contraseña.',
		veiculo: 'Vehículo',
		veiculoExcluidoComSucesso: 'Vehículo eliminado correctamente',
		velocidade: 'Velocidad',
		velocidadeAtual: 'Velocidad actual',
		velocidadeMedia: 'Velocidad Media',
		vencido: 'Vencido',
		vencimento: 'Fecha de vencimiento',
		vencimentos: 'Vencimiento',
		ver: 'Ver',
		verAcionamentoECorte: 'Ver marcha y parada',
		verDecolagemEPouso: 'Ver despegue y aterrizaje',
		verEstoque: 'Ver stock',
		verTodos: 'Ver todos',
		verificaBloqueioDiscrepancia: 'Comprobar discrepancia de bloqueo',
		verificacao: 'MARQUE LA FORMA DE EJECUCIÓN DE LA MANIOBRA EN EL LUGAR CORRESPONDIENTE',
		verificacaoDoVor: 'Verificación VOR',
		verificacaoSePodeExcluir: 'Comprobar si se puede excluir',
		verificados: 'Escaneado',
		verificando: 'Viendo',
		verificandoSePodePreencher: 'Comprobar si puede llenar',
		versao: 'Versión',
		versaoApi: 'Versión de Api',
		versaoArquivo: 'Versión del archivo',
		vidaUtil: 'Esperanza de vida',
		visaoGeral: 'Visión General',
		visualizacoes: 'Puntos de vista',
		visualizar: 'Visualizar',
		visualizarMalha: 'Ver malla',
		visualizarOrdemServico: 'Ver Orden de Servicio',
		visualizarRelatorio: 'Vista del informe',
		vitima: 'Víctima',
		vitimas: 'Víctimas',
		viuvo: 'Viuvo(a)',
		voadas: 'Voladas',
		voando: 'Volando',
		voce: 'Usted',
		voceEAAutoridadeSolicitante: 'Usted es la autoridad solicitante?',
		voceJaAddEssePerfil: 'Usted ha agregado este perfil',
		voceJaAddItem: 'Te ha añadido este artículo.',
		voceJaCadastrouItem: 'Usted ya ha registrado este artículo.',
		voceNaoPodeAgrupar: 'Usted no puede desagrupar esos tramos, ya se han llenado.',
		voceNaoPodeExcluirEditando: 'Usted no puede excluir, alguien está llenando el diario.',
		voceNovaSenha: 'Debe introducir la nueva contraseña.',
		voceTem: 'Tú tienes',
		voceTemAddUmPerfil: 'Usted tiene que agregar al menos un perfil.',
		voceTemQueEscolherUnidade: 'Usted tiene que agregar al menos una unidad.',
		voceTemQueEsperarPois: 'Usted tiene que esperar, pues',
		voltar: 'Volver',
		voltarMapa: 'Volver al mapa',
		volume: 'Volumen',
		volumeAtual: 'Volumen actual',
		volumeAtualMovimentacaoCombustivel: 'Volumen actual(l)',
		volumeFinalMovimentacaoCombustivel: 'Volumen final (l)',
		volumeMovimentacaoCombustivel: 'Volumen (l)',
		voo: 'Vuelo',
		vooAdicionadoSucesso: 'Vuelo añadido con éxito',
		vooAssinadoPeloMecanico: 'Vuelo firmado por el Mecánico',
		vooAssinadoPeloOperador: 'Vuelo firmado por el operador',
		vooAssinadoPeloPiloto: 'Vuelo firmado por el Piloto',
		vooAssinadoPor: 'Vuelo firmado por',
		vooDecimoCelula: 'Vuelo Décimo Célula',
		vooDecimoMotor: 'Vuelo Décimo Motor',
		vooDeveConterPiloto: 'El vuelo de instrucción debe contener un "Piloto en instrucción"',
		vooEspecial: 'vuelo especial',
		vooLegado: 'vuelo heredado',
		vooNaoPreenchido: 'Vuelo no rellenado',
		vooPreenchidoPor: 'Vuelo completado',
		vooRegular: 'Vuelo Regular',
		vooSalvo: 'Vuelo guardado correctamente',
		voos: 'Vuelos',
		wsdlCampFeed: 'WSDL Feed',
		wsdlCampGeneral: 'WSDL General',
		wsdlCampStatus: 'WSDL Status',
		wsdlCampoWorkOrder: 'WSDL Work Order',
		zonaQuenteCriminalidade: 'Zona Caliente de Criminalidad',
		zoomAeronave: 'Zoom Aircraft',
		zoomMobile: 'Zoom (móvil)',
		zoomPrincipal: 'Zoom principal',
		zoomRastreamento: 'Seguimiento de zoom',
		zqc: 'ZCC',
	},
	login: {
		digiteLogin: 'Digite su nombre de usuario',
		digiteSenha: 'Digite su contraseña',
		entrando: 'Entrando',
		entrar: 'Entrar',
		textoErro: 'Usuario o contraseña no válidos',
	},
	menu: {
		administracao: 'Administración general',
		comercial: 'Comercial',
		despachoComercial: 'Despacho Comercial',
		gestaoMalhaComercial: 'Gestión de Redes Comerciales',
		menuAdministracao: 'Administración',
		menuCertificados: 'Certificados',
		menuGeral: 'General',
		menuGerenciais: 'Gerenciales',
		menuManutencao: 'Mantenimiento',
		menuManutencaoAeronave: 'Aeronave',
		menuMissao: 'Misión',
		menuMonitoraAeronaves: 'Aeronaves',
		menuOrdem: 'Orden',
		menuRastreamento: 'Seguimiento',
		menuRelatorios: 'Informes',
		sairSistema: '¿Desea salir del sistema?',
		segurancaOperacional: 'Seguridad operacional',
		segurancaOperacionalOperacional: 'Operacional',
		segurancaOperacionalSeguranca: 'Seguridad',
	},
	menuAGCadAula: {
		aberta: 'Abierta',
		aula: 'Lección',
		aulaAtualizada: 'Lección actualizada',
		aulaCancelada: 'Lección cancelada',
		aulaEncerrada: 'Lección cerrada',
		aulaInserida: 'Lección insertada',
		aulaReaberta: 'Lección reabierta',
		aulas: 'Lecciones',
		aulasEFrequencias: 'Lecciones e Frecuencias',
		cancelada: 'Cancelada',
		duracaoNaoPodeMaiorQue: 'La dutación no puede ser mayor que',
		encerrada: 'Cerrada',
		frequencias: 'Frecuencias',
		msgAjudaAula: 'Haga clic en las cartas de la tabla para editar o tirar frecuencias.',
		presente: 'Presente',
	},
	menuAGCadTurma: {
		abertaParaInscricao: 'Inscripción abierta',
		emAndamento: 'En curso',
		excluirTurma: '¿Desea EXCLUIR esta Clase?',
		finalizada: 'Cerrada',
		novaTurma: 'Nueva Clase',
		turmaAtualizada: 'Clase actualizada',
		turmaInserida: 'Clase insertada',
		turmaRemovida: 'Clase eliminada correctamente',
		turmaTitulo: 'Clase',
	},
	menuAGcadAluno: {
		acidente: 'En caso de accidente avisar a la',
		alergico: 'Es alérgico a algún tipo de medicamentos (s)? Describirlo (s)',
		contato1: 'Teléfono Principal',
		contato2: 'Teléfono Celular',
		contato3: 'Contacto 3',
		dadosPessoais: 'Datos Personales',
		doSecao: 'Sección',
		doc1: 'Documento 1',
		doc2: 'Documento 2',
		doc3: 'Documento 3',
		docCategoria: 'Categoría',
		docCertidaoDeReservista: 'Certificado de Reservista',
		docCic: 'RUC',
		docDataExpedicao: 'Fecha de emisión',
		docIdentidade: 'Identidad',
		docOrgaoExpeditor: 'Órgano Expedidor',
		docTituloEleitor: 'Título de elector',
		docZona: 'Zona',
		documentacao: 'Documentación',
		doutorado: 'Doctorado',
		empresa: 'Empresa',
		ensinoFundamental: 'Escuela',
		ensinoMedio: 'Bachillerato',
		entende: 'Entiende',
		escolhaNivelInstrucao: 'Eligir su nivel de instrucción',
		escreve: 'Escribió',
		eulieaceitootermo: 'He leído y estoy de acuerdo con los términos anteriores.',
		fala: 'Habla',
		fatorRH: 'Factor RH',
		filiacao: 'Afiliación',
		grauParentesco: 'Grado de parentezco',
		habIFRaviaoP: 'Habilitación IFR Avión - Práctico',
		habIFRaviaoT: 'Habilitación IFR Avión - Teórico',
		habIFRhelicopteroP: 'Habilitação IFR Helicóptero - Prático',
		habIFRhelicopteroT: 'Habilitação IFR Helicóptero - Teórico',
		habilitacao: 'Para los Portadores de Habilitación',
		idioma: 'Idioma',
		idiomasEstrangeiros: 'Idiomas Extranjeros',
		infoAdicionais: 'Informaciones adicionales',
		inscricaoSalva: 'La inscripción se salva con éxito!',
		le: 'Lee',
		menuAGalunoAdm: 'Administración',
		menuAGalunoCargo: 'Cargo',
		menuAGalunoDoc: 'Documento',
		menuAGalunoEscolar: 'Escolar',
		menuAGalunoFicha: 'Ficha de Inscripción',
		menuAGalunoInsc: 'Inscripción',
		menuAGalunoInscs: 'Inscripciones',
		menuAGalunoNovaInsc: 'Nueva Inscripción',
		menuAGalunoSexo: 'Sexo',
		mestrado: 'Máster',
		nivelInstrucao: 'Nível de Instrucción',
		nomeEmpresa: 'Nombre de la Empresa',
		nomeMae: 'Nombre de la Madre',
		nomePai: 'Nome del Padre',
		numeroInscricao: 'Número de la inscripción',
		outrasInfo: 'Otras Informaciones',
		paraPortadoresDeLicenca: 'Para los Portadores de licencias',
		pilotoCPaviao: 'Piloto Comercial de Avión - Práctico',
		pilotoCPhelicoptero: 'Piloto Comercial de Helicóptero - Práctico',
		pilotoCTaviao: 'Piloto Comercial de Avión - Teórico',
		pilotoCThelicoptero: 'Piloto Comercial de Helicóptero - Teórico',
		pilotoPPaviao: 'Piloto Privado de Avión - Práctico',
		pilotoPPhelicoptero: 'Piloto Privado de Helicóptero - Práctico',
		pilotoPTaviao: 'Piloto Privado de Avión - Teórico',
		pilotoPThelicoptero: 'Piloto Privado de Helicóptero - Teórico',
		requisitosParaOtreinamento: 'Requisitos para este treinamento.',
		sebrac: 'SEBRAC',
		simuladorVoo: 'Simulador de vuelo',
		superiorCompleto: 'Superior',
		tipoSanguineo: 'Tipo Sanguíneo',
		treinamento: 'Treinamento',
		voltarParaLista: 'Volver a la lista',
	},
	menuAGcadMatricula: {
		addMatricula: 'Matrícula insertada',
		attMatricula: 'Matrícula actualizada',
		cadHabilitacao: 'Habilitación',
		cadMatriculaTitulo: 'Matrícula',
		cadNomeAluno: 'Nombre del Alumno',
		cadNovaMatricula: 'Nueva Matrícula',
		cadNumero: 'Número',
		cadTreinamento: 'Treinamento',
		fechaMatricula: 'Matrícula encerrada',
	},
	menuAGcadPagamento: {
		addPagamento: 'Pagamento insertado',
		attPagamento: 'Pagamento actualizado',
		cadNovoPagamento: 'Nuevo Pagamento',
		cadPagamentoTitulo: 'Pagamento',
		cadValor: 'Valor',
		codigoPagamento: 'Código',
		fechaPagamento: 'Pagamento encerrado',
		nomeAluno: 'Nombre - Alumno',
		treinamentoHab: 'Treinamento',
	},
	menuAGcadTreinamento: {
		cadEditarTreinamento: 'Editar Treinamento',
		cadNomeTreinamento: 'Nombre del Treinamento',
		cadNovoTreinamento: 'Novo Treinamento',
		cadTreinamentoAtualizado: 'Treinamento actualizado',
		cadTreinamentoCargaHoraria: 'Carga Horaria',
		cadTreinamentoCliente: 'Clic en el \'Nuevo',
		cadTreinamentoDisciplina: 'Disciplinas',
		cadTreinamentoNovaDisciplina: 'Insertar Nueva Disciplina',
		cadTreinamentoPratico: 'Práctico',
		cadTreinamentoSecretaria: 'Escuela de vuelo',
		cadTreinamentoSucesso: 'Treinamento Insertado',
		cadTreinamentoTeorico: 'Teórico',
		cadTreinamentoTitulo: 'Treinamentos',
		cadTreinamentomenuMtexto2: 'clic en el ícono',
		cadTreinamentomenuMtexto3: 'na lista opuesta.',
		cadValorTreinamento: 'Valor del Treinamento',
		disciplinaAvaliativa: '¿Este curso es evaluativo?',
		frequenciaParaAprov: 'Frecuencia de aprobación',
		notaMinimalParaAprov: 'Nota mínima de aprobación',
	},
	menuAGinspecao: {
		menuAGaAeronave: 'de Aeronaves',
		menuAGatualizado: 'Inspección actualizada con éxito.',
		menuAGcCiclo: 'Ciclo',
		menuAGdadosInspecao: 'Datos de Inspección',
		menuAGdescInspecao: 'Descripción de la inspección',
		menuAGeditarInspecao: 'Editar Inspección',
		menuAGgInspecao: 'Grupo Inspección',
		menuAGhHomem: 'Hora/Hombre',
		menuAGiAnos: 'Años',
		menuAGiDescricao: 'Descripción',
		menuAGiDias: 'Días',
		menuAGiHoras: 'Horas',
		menuAGiInspecao: 'Inspección',
		menuAGiMeses: 'Meses',
		menuAGinserido: 'Inspección insertada con éxito.',
		menuAGmInspecao: 'Modelo',
		menuAGmodelAeronave: 'Modelo',
		menuAGnInspecao: 'Naturaleza',
		menuAGnovaInspecao: 'Nueva Inspección',
		menuAGnumPeca: 'Número Parte',
		menuAGnumSerie: 'Número Serie',
		menuAGtInspecao: 'Tipo',
		menuAGtextoI1: 'Clic en \'Nueva Inspección\'',
		menuAGtextoI2: 'Clic en el ícono',
		menuAGtextoI3: ' na lista opuesta lado.',
		menuAGvidaUtil: 'Vida útil de la Inspección',
	},
	menuAGnovaEscala: {
		menuAGbusca: 'Búsqueda',
		menuAGcarregar: 'Cargar',
		menuAGtipoEscala: 'Tipo',
	},
	menuAGnovoCargo: {
		menuAGaddCargo: 'Cargo insertado',
		menuAGattCargo: 'Cargo actualizado',
		menuAGcadCargo: 'Nuevo Cargo',
		menuAGcadCargo2: 'Registro de cargo',
		menuAGdescCargo: 'Descripción',
		menuAGdescCargo2: 'Descripción del trabajo',
		menuAGeditCargo: 'Editar Cargo',
		menuAGtexto1: 'Clic en \'Nuevo\'',
		menuAGtexto2: 'Clic en el icono',
		menuAGtexto3: ' na lista opuesta.',
	},
	menuAGnovoGrupo: {
		cadGrupoTitulo: 'Grupo de Inspección',
		menuAGaddGrupo: 'Grupo insertado',
		menuAGattGrupo: 'Grupo actualizado',
		menuAGcadGrupo: 'Nuevo Grupo',
		menuAGdescGrupo: 'Descripción',
		menuAGdescGrupo2: 'Descripción del grupo',
		menuAGeditGrupo: 'Editar',
		menuAGtextoG1: 'Clic en \'Nuevo\'',
		menuAGtextoG2: 'Clic en el icono',
		menuAGtextoG3: ' na lista opuesta.',
		naturezaManutencao: 'Naturaleza De Mantenimiento',
	},
	menuAGnovoOrgao: {
		cadOrgaoTitulo: 'Registro del Órgano',
		menuAGaddOrgao: 'Órgano insertado',
		menuAGattOrgao: 'Órgano actualizado',
		menuAGcadOrgao: 'Nuovo Órgano',
		menuAGdescOrgao: 'Descripción',
		menuAGdescOrgao2: 'Descripción del órgano',
		menuAGeditOrgao: 'Editar Órgano',
		menuAGtextoG1: 'Clic en \'Nuevo\'',
		menuAGtextoG2: 'Clic en el icono',
		menuAGtextoG3: ' na lista opuesta.',
	},
	menuAGnovoPosto: {
		menuAGaddPosto: 'Puesto insertado',
		menuAGattPosto: 'Puesto actualizado',
		menuAGcadPosto: 'Nuevo Puesto',
		menuAGdescPosto: 'Descripción',
		menuAGdescPosto2: 'Descripción del trabajo',
		menuAGeditPosto: 'Editar Puesto',
		menuAGtexto1: 'Clic en \'Nuevo\'',
		menuAGtexto2: 'Clic en el icono',
		menuAGtexto3: ' la lista opuesta.',
	},
	menuAGnovoUsuario: {
		menuAGacesso: 'Acceso al sistema',
		menuAGanac: 'Código ANAC',
		menuAGbairro: 'Barrio',
		menuAGbase: 'Base',
		menuAGbranco: 'En blanco, mantener la misma contraseña.',
		menuAGcadUser: 'Nuevo Usuario',
		menuAGcadastroUsuario: 'Registro de usuarios',
		menuAGcargo: 'Cargo',
		menuAGcargo2: 'Cargo',
		menuAGcel1: 'Celular 1',
		menuAGcel2: 'Celular 2',
		menuAGcelular: 'Celular',
		menuAGcep: 'CEP',
		menuAGcidade: 'Ciudad',
		menuAGcomplemento: 'Complemento',
		menuAGcpf: 'Identidad',
		menuAGdadosCadastrais: 'Datos de Registro',
		menuAGdepto: 'Departamento',
		menuAGdesejaExcluir: '¿Desea EXCLUIR este usuario?',
		menuAGeditarUsuario: 'Editar usuario',
		menuAGemail: 'Correo electrónico',
		menuAGestado: 'DPTO',
		menuAGexcluir: 'Excluir usuario',
		menuAGguarnicao: '¿Forma parte de la guarnición?',
		menuAGguarnicao2: 'Guarnición',
		menuAGid: 'Identidad',
		menuAGlogin: 'Nombre de Usuario',
		menuAGlogradouro: 'Via Pública',
		menuAGmarcarTodos: 'Marcar Todos',
		menuAGmatricula: 'Matrícula',
		menuAGnao: 'No',
		menuAGnome: 'Nombre',
		menuAGnomeGuerra: 'Nombre de Guerra',
		menuAGnum: 'Número',
		menuAGnumOrdem: 'Número de Orden',
		menuAGorgao: 'Órgano',
		menuAGposto: 'Puesto/Graduación',
		menuAGprivilegio: 'Privilegios del Sistema',
		menuAGremover: 'Eliminar todos los privilegios',
		menuAGsenha: 'Contraseña',
		menuAGsim: 'Sí',
		menuAGsistema: '¿Tiene acceso al sistema?',
		menuAGtel1: 'Teléfono 1',
		menuAGtel2: 'Teléfono 2',
		menuAGtipo: 'Tipo',
		menuAGtipoCertificado: 'Tipo Certificado',
		menuAGusuarioAdicionado: 'Usuario agregado con éxito.',
		menuAGusuarioAtualizado: 'Usuario actualizado con éxito.',
		menuAGusuarioExcluido: 'Usuario eliminado con éxito.',
		menuAGvalidadeCertificado: 'Validez Certificado',
		msgPrivilegio: 'Añadir quiere más privilegios?',
		pClasse: '1era Clase',
		sClasse: '2da Clase',
		tClasse: '3ra Clase',
	},
	menuAGpermutas: {
		menuAGaeronave: 'Aeronave involucrada:',
		menuAGchefiaEspecial: 'Jefatura Especial del Área de Seguridad Pública – CAESP',
		menuAGcidade: 'Ciudad:',
		menuAGconclusao: 'Conclusión',
		menuAGdata: 'Fecha:',
		menuAGemail: 'Correo electrónico:',
		menuAGenvolvidos: 'Involucrados:',
		menuAGestado: 'DPTO:',
		menuAGfim: 'Fin',
		menuAGinicio: 'Inicio',
		menuAGlocal: 'Lugar:',
		menuAGnome: 'Nombre:',
		menuAGparecer: 'Parecer',
		menuAGresposta: 'Respuesta:',
		menuAGresposta2: 'Respuesta',
		menuAGsalvo: '¡Guardado con éxito!',
		menuAGsecretariaAlagoas: 'Secretaría de Estado de Seguridad Pública de Alagoas',
		menuAGsituacao: 'Situación:',
		menuAGsolicitado: 'Solicitado',
		menuAGtel: 'Teléfono:',
		menuAGtipo: 'Tipo:',
		menuAGtipo2: 'Tipo',
	},
	menuAGplanoManutencao: {
		comprimentoDeBoletins: 'CUMPLIMIENTO DE BOLETINES DE AERONAVEGABILIDAD',
		comprimentodeBoletinsServico: 'CUMPLIMIENTO DE BOLETINES DE SERVICIOS',
		controleDeComponentesCeula: 'CONTROL DE COMPONENTES',
		controleDeComponentesMotor: 'CONTROL DE COMPONENTES',
		inspecoesAcessoriosMotor: 'INSPECCIONES PROGRAMADAS DE ACCESORIOS',
		inspecoesProgramadas: 'INSPECCIONES PROGRAMADAS',
		inspecoesProgramadasEquipamento: 'INSPECCIONES PROGRAMADAS DE EQUIPAMIENTOS',
		inspecoesProgramadasMotor: 'INSPECCIONES PROGRAMADAS',
		inspecoesRegulamentares: 'INSPECCIONES REGLAMENTARIAS',
		manuAGNenhumaEncontrada: 'No se encontraron inspecciones.',
		menuAGInspecaoAtualizada: 'Inspecciones actualizadas.',
		menuAGaddInspecao: 'Agregar Inspección al Plan',
		menuAGaddTodas: 'Agregar Todas',
		menuAGcelula: 'Célula',
		menuAGdetalhes: 'Detalles',
		menuAGinspDetalhe: 'Detalles de la Inspección',
		menuAGinspecao: 'Inspección',
		menuAGinspecoes: 'Inspección',
		menuAGmodelo: 'Modelo',
		menuAGmotor: 'Motor',
		menuAGpeca: 'Parte',
		menuAGperiodicidade: 'Periodicidad',
		menuAGplano: 'Plan de Mantenimiento',
		menuAGremoveTodas: 'Eliminar Todas',
		menuAGserie: 'Serie',
		revalidacoes: 'REVALIDACIONES Y CERTIFICACIONES',
	},
	menuAGprevencao: {
		menuAGNovaPrevencao: 'Nueva Prevención',
		menuAGaeronave: 'Aeronave:',
		menuAGaeronave2: 'Aeronave',
		menuAGcidade: 'Ciudad:',
		menuAGcidade2: 'Ciudad',
		menuAGconcluir: 'Concluir prevención',
		menuAGconclusao: 'Descripción de la conclusión',
		menuAGdataOcorrencia: 'Fecha de la Ocurrencia:',
		menuAGdescricao: 'Descripción:',
		menuAGemail: 'Correo electrónico:',
		menuAGenvolvidos: 'Personal Involucrado:',
		menuAGlocal: 'Lugar de la Ocurrencia:',
		menuAGpPrevencao: 'Prevención',
		menuAGprevencaoConcluida: 'Prevención concluída.',
		menuAGrelato: 'Informe de Prevención',
		menuAGrelatoOcorrencia: 'El informe de la ocurrencia aquí presentada tiene como única finalidad el incentivo a la seguridad operacional, por lo cual su uso se destina exclusivamente a la prevención de accidentes. NO ES NECESARIO FIRMAR O IDENTIFICARSE',
		menuAGrelator: 'Relator:',
		menuAGrelatorio: 'Informe de Prevención',
		menuAGrelatorioAdicionado: 'Informe agregado con éxito.',
	},
	menuAGstatus: {
		cadStatusTitulo: 'Registro de Estado',
		menuAGaddStatus: 'Estado  insertado',
		menuAGattStatus: 'Estado actualizado',
		menuAGcadStatus: 'Nuevo Estado',
		menuAGcadStatus2: 'Registrar estado',
		menuAGdescStatus: 'Descripción',
		menuAGdescStatus2: 'Descripción del estado',
		menuAGeditStatus: 'Editar estado',
		menuAGtexto1: 'Clic on \'Nuevo\'',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
		obrigaStatus: 'Requieren la introducción de una nota al seleccionar este estado?',
	},
	menuAGtipoAfastamento: {
		cadAfastamentoTitulo: 'Aclaramiento de registro',
		menuAGaddAfastamento: 'Aclaramiento insertado',
		menuAGattAfastamento: 'Aclaramiento actualizado',
		menuAGcadAfastamento: 'Nuevo Aclaramiento',
		menuAGdescAfastamento: 'Descripción',
		menuAGdescAfastamento2: 'Descripción del aclaramiento',
		menuAGeditAfastamento: 'Editar Aclaramiento',
		menuAGtextoG1: 'Clic en \'Nuevo\'',
		menuAGtextoG2: 'Clic en el ícono',
		menuAGtextoG3: ' na lista opuesta.',
	},
	menuAGtipoGuarnicao: {
		cadGuarnicaoTitulo: 'Registro de Tipo de Guarnición',
		menuAGaddGuarnicao: 'Guarnición insertada',
		menuAGattGuarnicao: 'Guarnición actualizada',
		menuAGcadGuarnicao: 'Nueva Guarnición',
		menuAGdescGuarnicao: 'Descripción',
		menuAGdescGuarnicao2: 'Descripción de la guarnición',
		menuAGeditGuarnição: 'Editar Guarnición',
		menuAGgOrdem: 'Orden',
		menuAGgSigla: 'Acrónimo',
		menuAGtextoG1: 'Clic en \'Nueva\'',
		menuAGtextoG2: 'Clic en el ícono',
		menuAGtextoG3: ' na lista opuesta.',
	},
	menuAGtipoMissao: {
		cadMissaoTitulo: 'Registro de Tipo de Misión',
		menuAGaddMissao: 'Misión insertada',
		menuAGattMissao: 'Misión actualizada',
		menuAGcadMissao: 'Nueva Misión',
		menuAGdescMissao: 'Descripción',
		menuAGdescMissao2: 'Descripción de la misión',
		menuAGeditMissao: 'Editar Misión',
		menuAGtexto1: 'Clic en \'Nueva\'',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
	},
	menuAGtipoNatureza: {
		cadNaturezaTitulo: 'La Naturaleza de Registro',
		menuAGaddNatureza: 'Naturaleza insertada',
		menuAGattNatureza: 'Naturaleza actualizada',
		menuAGcadNatureza: 'Nueva Naturaleza',
		menuAGdescNatureza: 'Descripción',
		menuAGdescNatureza2: 'Descripción de la naturaleza',
		menuAGeditNatureza: 'Editar Naturaleza',
		menuAGnSigla: 'Acrónimo',
		menuAGtexto1: 'Clic en \'Nueva\'',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
	},
	menuAGtipoOcorrencia: {
		cadOcorrenciaTitulo: 'Registro de Tipo de Ocurrencia',
		menuAGaddOcorrencia: 'Ocurrencia insertada',
		menuAGattOcorrencia: 'Ocurrencia actualizada',
		menuAGcadOcorrencia: 'Nueva Ocurrencia',
		menuAGdescOcorrencia: 'Descripción',
		menuAGdescOcorrencia2: 'Descripción da ocurrencia',
		menuAGeditOcorrencia: 'Editar Ocurrencia',
		menuAGtexto1: 'Clic en \'Nova\'',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
	},
	menuAGtipoPrioridade: {
		cadPrioridadeTitulo: 'Registro de Tipo de Prioridad',
		menuAGaddPrioridade: 'Prioridad insertada',
		menuAGattPrioridade: 'Prioridad actualizada',
		menuAGcadPrioridade: 'Nueva Prioridad',
		menuAGdescPrioridade: 'Descripción',
		menuAGdescPrioridade2: 'Descripción de Prioridad',
		menuAGeditPrioridade: 'Editar Prioridad',
		menuAGtexto1: 'Clic en \'Nueva\'',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
	},
	menuAfastamento: {
		menuAadicionado: 'Pedido agregado con éxito.',
		menuAaprovar: 'Aprobar',
		menuAatualizado: 'Pedido actualizado con éxito.',
		menuAreprovar: 'Reprobar',
		tipo: 'Tipo:',
	},
	menuArapiraca: {
		menuAescala: 'Cargando escala Arapicara',
		menuAnpg: 'Nombre- Post/Grad',
		menuAsalvo: 'Guardado',
	},
	menuCadCiv: {
		CivAtualizado: 'CIV actualizada',
		CivRemovida: 'CIV eliminada correctamente',
		CivSucesso: 'CIV insertada',
		cadCiv: 'Registro de CIV',
		pilotoParticipante: 'Piloto Participante',
	},
	menuCadHabilitacao: {
		EditarHabi: 'Editar Habilitación',
		HabiAtualizado: 'Habilitación Actualizado',
		HabiCliente: 'Clic en el \'Novo\'',
		HabiDescricao: 'Descripción',
		HabiSecretaria: 'Escuela de vuelo',
		HabiSucesso: 'Habilitación Insertado',
		HabiTexto1: 'clic en el ícono',
		HabiTexto2: 'na lista opuesta.',
		HabiTitulo: 'Habilitación',
		NovoHabi: 'Nuevo Habilitación',
	},
	menuCadPacote: {
		EditarPacote: 'Editar Paquete',
		NovoPacote: 'Nuevo Paquete',
		PacoteAtualizado: 'Paquete actualizado',
		PacoteCliente: 'Clic en el \'Novo\'',
		PacoteDescricao: 'Descripción',
		PacoteNumeroHoras: 'Carga Horario',
		PacotePratico: 'Práctico',
		PacoteSecretaria: 'Escuela de vuelo',
		PacoteSucesso: 'Paquete Insertado',
		PacoteTeorico: 'Teórico',
		PacoteTexto1: 'clic en el ícono',
		PacoteTexto2: 'na lista opuesta.',
		PacoteTitulo: 'Paquete',
		ValorPacote: 'Valor del Paquete',
	},
	menuEdicaoDiario: {
		horimetroFinal: 'Horas finales de vuelo',
		horimetroInicial: 'Horas iniciales de vuelo',
		nenhumEmpenhoAdicionado: 'Sin esfuerzo agregado',
		nenhumMotorAdicionado: 'Sin motor agregado',
		tempoDeVoo: 'Tiempo de vuelo',
	},
	menuErro: {
		menuEtitulo: '¡Ups!',
		menuEtitulo2: '¡Oh-o!',
		menuTextoErro: '¿Ocurrió algún error al intentar realizar esta acción?',
		menuTextoErro2: 'Algo me dice que no puede hacerlo.',
	},
	menuEscala: {
		copilotos: 'Copilotos',
		menuCarregaEscala: 'Cargando escala',
		menuElegenda: 'Subtítulo',
		menuEtotalDia: 'Total de servicios por día',
		menuEvermelho: 'Corrija los campos en rojo.',
		menuRemover: 'Eliminar',
		menuSalvaEscala: 'Guardado',
		pilotoEcopiloto: 'Piloto y Copiloto',
		pilotos: 'Pilotos',
		radioOperador: 'Operador de radio',
		secaoManutencao: 'Sección de Mantenimiento',
		sessaoManutencao: 'Sesión de Mantenimiento',
		tripulanteArapiraca: 'Tripulante Arapiraca',
		tripulanteMaceio: 'Tripulante Maceió',
		tripulanteOperacional: 'Tripulante Operacional',
	},
	menuMaceio: {
		menuMmaceio: 'Cargando escala Maceió',
		menuMnpg: 'Nombre- Post/Grad',
		menuMsalvo: 'Guardado',
		menuMtripulante: 'Tripulante ya agregado',
	},
	menuMalha: {
		editarSemana: 'Editar semana',
		novaSemana: 'Agregar semana',
	},
	menuManutencao: {
		menuMapoio: 'Apoyo Suelo',
		menuMapu: 'APU',
		menuMasaFixa: 'Ciclo del motor',
		menuMatualizaManutencao: 'Actualizar Mantenimiento',
		menuMatualizada: 'Mantenimiento actualizado con éxito',
		menuMcelula: 'Célula',
		menuMciclon1: 'Ciclos N1',
		menuMciclon2: 'Ciclos N2',
		menuMciclosNG: 'Ciclos NG',
		menuMciclosT1: 'Ciclos NF',
		menuMcodinome: 'Nombre código',
		menuMcontrolComp: 'Control de Componentes',
		menuMcontrolCompDE: 'Control de componentes de',
		menuMctm: 'C T M',
		menuMdataPrevista: 'Fecha Prevista',
		menuMdescricao: 'Descripción',
		menuMdetalhes: 'Actualizar',
		menuMdisponibilidade: 'Disponibilidad',
		menuMescolha: 'Escoja una opción',
		menuMeventos: 'Eventos',
		menuMf: 'V - VACACIONES',
		menuMhHomemHora: 'Hombres/Hora',
		menuMhorasAtuais: 'Horas Actuales',
		menuMhorasTotais: 'Horas Totales',
		menuMhrsAtuais: 'Horas Actuales',
		menuMinspProg: 'Inspecciones Programadas',
		menuMinspProgDE: 'Inspecciones programadas de',
		menuMinspProgEquip: 'Inspecciones Programadas de Equipamientos',
		menuMinspReg: 'Inspecciones Reglamentarias',
		menuMmodelo: 'Modelo',
		menuMmotor: 'Motor',
		menuMnumSerie: 'Número Serie',
		menuMpousosAtuais: 'Aterrizajes Actuales',
		menuMrevalidaC: 'Revalidaciones y Certificaciones',
		menuMtecnico: 'Técnico de mantenimiento',
		menuMtotal: 'Total',
		menuMx: 'X - ESTÁ ESCALADO',
		menuNivel: 'Nivel',
		menuTipo: 'Tipo',
	},
	menuMatricula: {
		assinaturaAluno: 'FIRMA DEL ALUMNO(A)',
		atestadoBonsAntecedentes: 'Certificado de Boa Conduta',
		candidadoEstrangeiro: 'Candidato Extranjero?',
		cartaoIdentidade: 'Tarjeta de Identidad',
		carteriaIdentidadeEstrangeirosValidade: 'Carnet de identidad para extranjeros con validez de permanencia',
		casoPossuaLicenca: 'Si tiene licencia',
		certidaoCapacidadeFisisca: 'Certificado de Capacidad Física',
		certidaoEscolaridade: 'Certificado de Escolaridad',
		copiaCertificadoEscolaridadeEstrangeiro: 'Copia del certificado de escolaridad (traducido oficialmente) de la enseñanza fundamental',
		copiaDocumentoViagem: 'Copia del documento de viaje',
		copiaLicencaAtividade: 'Copia de la licencia de la actividad específica o documento equivalente (traducido oficialmente)',
		cpf: 'RUC',
		declaracaoSubJudice: 'Declaración de la solicitud de que no se encuentra SUB-JUDICE',
		densidade: 'Densidad',
		documentacaoApresentada: 'Documentación presentada (Candidatos)',
		documentacaoApresentadaEstrangeiros: 'Documentación presentada (Candidatos Extranjeros)',
		exibirMatricula: 'Ver la matrícula',
		informacoesMatricula: 'Información sobre la inscripción',
		matriculaSalva: 'Matrícula ¡Salva con éxito!',
		naoSalva: 'No Salva',
		numeroMatricula: 'Número de matrícula',
		permissaoResidencia: 'Permiso de residencia',
		requerimentoDoCantidado: 'Solicitud del Candidato',
		responsavelMatricula: 'RESPONSABLE DE LA MATRÍCULA',
		termoMatricula: 'Término de matrícula',
		termoTexto: 'DECLARACIÓN DE QUE ESTE(A) ALUMNO(A) ENCUENTRA MATRICULADO (A) EN ESTE TREINAMENTO, A PARTIR DE <strong>{{dataMatricula}}</strong>, MÁTRICULA <STRONG>{{matricula}}</strong>, YA ESTO ENTREGAS LAS COPIAS DE LA DOCUMENTACIÓN EXIGIDA, ACOMPAÑADAS DE <STRONG>{{qtd4x4}}</STRONG> RETRATOS 3X4.',
		tituloEleitor: 'Título de elector',
		utilizada: 'Usado',
		volume: 'Volumen',
		volumeAbastecido: 'Volumen suministrado',
		volumeAbastecidoUnidadeArmazenamento: 'Volumen suministrado (l)',
		volumeFinal: 'Volumen final',
		volumeReal: 'Volumen real',
	},
	menuMoficina: {
		cadOficinaTitulo: 'Registro de Taller',
		menuMaddOficina: 'Taller insertada',
		menuMattOficina: 'Taller actualizada',
		menuMcadOficina: 'Nueva Taller',
		menuMeditOficina: 'Editar Taller',
		menuMresponsavel: 'Responsable',
		menuMtexto1: 'Clic en \'Nueva Taller\'',
		menuMtexto2: 'Clic en el ícono',
		menuMtexto3: ' na lista opuesta.',
	},
	menuMonitoramento: {
		horaDia: 'Hora/Día',
		horaMes: 'Hora/Mes',
		menuAeronaveNaoVoou: 'La aeronave aún no vuela hoy.',
		menuMonitora: 'Monitoreo',
		menuMonitoraAeronaves: 'Aeronaves',
		menuTempoReal: 'Tiempo Real',
		nenhumaManutencao: 'No hay mantenimientos programados.',
		totalCiclosVoadios: 'Total de ciclos volados',
		voosDia: 'Vuelos del día',
	},
	menuMsolicitaManutencao: {
		menuMsolicitaAdd: 'Solicitud de mantenimiento actualizada.',
		menuMsolicitaAtt: 'Solicitud de mantenimiento insertada.',
		menuMsolicitaCancelar: '¿Desea cancelar esta solicitud de mantenimiento?',
		menuMsolicitaDisponibilidade: 'Disponibilidad',
		menuMsolicitaEscolha: 'Elija las inspecciones abajo',
		menuMsolicitaEvento: 'Evento',
		menuMsolicitaHhora: 'Hombres Hora',
		menuMsolicitaHtotais: 'Horas Totales',
		menuMsolicitaInspecoes: 'Inspecciones',
		menuMsolicitaManutencoes: 'Solicitudes de mantenimiento',
		menuMsolicitaMesesDias: 'Meses / Días',
		menuMsolicitaModalidade: 'Modo',
		menuMsolicitaNivel: 'Nivel',
		menuMsolicitaProxInspecao: 'Siguiente inspección',
		menuMsolicitaReferente: 'Solicitudes de aeronave',
		menuMsolicitaSelecione: 'Seleccione una o varias inspecciones a continuación y haga clic en AGREGAR',
		menuMsolicitaTipo: 'Tipo',
	},
	menuOpRadio: {
		carregando: 'Cargando escala rádio operador',
	},
	menuOrdemMissao: {
		menuMissao: 'Misión',
		menuNova: 'Nueva',
		menuNovaOrdem: 'Nueva Orden',
		menuOrdem: 'Orden',
		menuOrdemEscolha: 'Elección',
		menuOrdemSolicitacao: 'Solicitud',
		menuOrdemmissao: 'Orden Misión:',
	},
	menuOrgaoApoiados: {
		orgao: 'Órgano',
		orgaoApoiados: 'Órgano Apoyado',
		orgaoCadastro: 'Registro de Órgano',
		orgaosApoiados: 'Órganos Apoyados',
	},
	menuRGestatisticaVoo: {
		menuAeronave: 'Aeronave',
	},
	menuRGhorasVoadas: {
		menuRGaeronave: 'Aeronave',
		menuRGdataFim: 'Fecha Fin',
		menuRGdataInicio: 'Fecha Inicio',
		menuRGhorasReportadas: 'Horas Reportadas',
		menuRGou: 'O',
		menuRGrelatorio: 'Este informe tiene fines operacionales, pudiendo generar diferencias de más o de menos en el total de las horas voladas cuando se compara con la bitácora.',
	},
	menuRGoperacoes: {
		menuAeronave: 'Aeronave',
		menuRGcomb: 'Comb.',
		menuRGde: 'De',
		menuRGpara: 'Para',
		menuRGpartida: 'Partida',
		menuRGpax: 'Pasajeros',
		menuRGpousos: 'Aterrizajes',
		menuRGtdec: 'T Dec',
		menuRGtipo: 'Tipo',
		menuRGtvoo: 'T Vuelo',
		menuRelatorioOp: 'Informe de Operaciones',
		menuTipo: 'Tipo',
	},
	menuRGordemmissao: {
		menuOMadicionados: 'Agregados:',
		menuOMcargo: 'Cargo:',
		menuOMcoordenador: 'Coordinador:',
		menuOMdataInicio: 'El período de Orden de Misión debe estar entre el período de la Solicitud.',
		menuOMdataMaior: 'La fecha inicial no puede ser mayor que la fecha final.',
		menuOMemail: 'Correo electrónico:',
		menuOMenviar: 'Enviar y guardar',
		menuOMescolha: 'Elección',
		menuOMfim: 'Fin',
		menuOMguarnicao: 'Guarnición Aérea:',
		menuOMinicio: 'Inicio',
		menuOMlotacao: 'Capacidad:',
		menuOMmissao: 'Orden de Misión',
		menuOMnaoDisponivel: 'No disponible en este momento.',
		menuOMnome: 'Nombre:',
		menuOMoperacao: 'Operación:',
		menuOMordemAdicionada: 'Orden agregada con éxito.',
		menuOMordemAtualizada: 'Orden actualizada con éxito.',
		menuOMordemEncerrada: 'Orden terminada con éxito.',
		menuOMorgao: 'Organización:',
		menuOMprioridade: 'Prioridad:',
		menuOMsemdados: 'No se encuentran datos.',
		menuOMtelefone: 'Teléfono:',
		menuOMtripulantes: 'Tripulantes:',
	},
	menuRGsolicitacoes: {
		menuRGnome: 'Nombre:',
		menuRGoperacao: 'Operación:',
		menuRGorgao: 'Organización:',
		menuRGprioridade: 'Prioridad:',
		menuRGrSolicitacoes: 'Informe de Solicitudes',
		menuRGsemdados: 'No se encuentran datos.',
		menuRGsolicitacao: 'Solicitudes',
	},
	menuRastreamento: {
		menuRastrea: 'Seguimiento',
		menuRastreaAeronave: 'Aeronave',
		menuRmudar: 'Cambiar',
		menuRtotal: 'Total',
	},
	menuSegurancaOperacional: {
		acaoesMitigadoras: 'Acciones mitigantes',
		acionadoOrgaosExternos: 'Se han activado los órganos externos que forman parte de <PRE-XXX> y / o <PLEM-SXXX>?',
		acoesForamSuficienteFinal: 'Fueron suficientes acciones de mitigación?',
		analiseEvento: 'Análisis de eventos',
		analiseFinal: 'Análisis Finales',
		analiseInicial: 'Analisis inicial',
		cliente: 'Cliente',
		codigoControleInterno: 'Código de control interno',
		codigoOACI: 'Código de la OACI',
		comoFoiAcionado: 'Cómo se activó',
		condicoesEmQue: 'Condiciones bajo las cuales',
		dataDoOcorrido: 'Fecha de ocurrencia',
		deficienciasIdentificadas: 'Deficiencias encontradas en la información',
		deficienciasPorFaltaRecursos: 'Deficiencias identificadas',
		descricaoEvento: 'Descripción del evento.',
		disponibilizacaoAcomodacoes: 'Se ha puesto a disposición de los miembros de la familia y del público en general?',
		enviadaEm: 'Respuesta enviada al Relator sobre',
		evacuacaoTripulantes: 'Descripción de la evacuación de la tripulación / pasajeros.',
		eventoOperacionalRelatadoAspectos: 'El evento de seguridad operacional informado (ESO) involucra uno de los siguientes aspectos',
		executivo: 'Ejecutivo',
		exemplar: 'La copia ',
		existiaExemplar: 'Hubo una copia ',
		fatoresContribuintes: 'Factores contribuyentes',
		foramAdequados: ' fueron adecuados y suficientes para el desmantelamiento de la pista?',
		horaDoOcorrido: 'Hora de ocurrencia',
		houveDerramamentoCombustivel: 'Se derramó combustible o aceite en la pista o ubicación?',
		identifiqueAsCargas: 'Identificar la carga peligrosa presente en el evento:',
		informacoesAtenderam: 'La información satisfizo las necesidades?',
		informante: 'Quien reportó',
		localDoOcorrido: 'Ubicación',
		motivosAcoesNaoSuficiente: 'Razones de no suficiencia',
		numeroDocumentoOrigem: 'Documento fuente No.',
		organizacoesEnvolvidas: 'Organizaciones involucradas',
		orgaosEnvolvidos: 'Cuerpos externos involucrados',
		outrasInformacoes: 'Otras informaciones',
		paralisacaoOperacoes: 'Se detuvieron las operaciones?',
		pistaInterditada: 'Estaba bloqueada la pista?',
		probabilidade: 'Probabilidad de que vuelva a ocurrir ESO',
		quaisAcoesAdicionaisAdotadas: '¿Qué acciones adicionales se deben tomar?',
		questionarioGestorSegurancaOperacional: 'Sobre el gerente de seguridad operacional',
		recursosDisponiveis: 'Los recursos disponibles en ',
		remetente: 'Nombre del remitente',
		respostaEnviadaAoRelator: 'Respuesta enviada al ponente?',
		setoresResponsaveis: 'Sectores responsables de mitigación',
		severidade: 'Gravedad si ocurre la peor consecuencia posible de este evento',
		situacaoRelatada: 'Situación reportada',
		tempoPistaInterditada: 'Tiempo de seguimiento bloqueado',
		tempoRetomadaOperacoes: 'Hora en que las operaciones volvieron a la normalidad',
		tipoSituacao: 'Tipo de situación',
		tolerabilidade: 'Tolerabilidad',
	},
	menuSolicitaApoio: {
		apoioAereo: 'Apoyo aéreo',
		codigoPnapa: 'Código Pnapa',
		corrigirCampos: 'Por favor, corrija los campos en rojo arriba.',
		dadosAtualizados: '¡Datos actualizados con éxito!',
		destino: 'Destino',
		escolhaArquivo: 'Escoja un archivo y haga clic en cargar.',
		escolherLocal: 'Debe escoger al menos un lugar.',
		menuCargo: 'Cargo',
		menuCoordenador: 'Coordinador Suelo',
		menuCoordenadorSolo: 'Coordinador Suelo',
		menuDataEfim: 'La fecha de inicio y fin son obligatorias',
		menuEscolha: 'Elección',
		menuFimOperacao: 'Fecha Fin Operación',
		menuGrauPrioridade: 'Grado de prioridad',
		menuInicioOperacao: 'Fecha Inicio Operación',
		menuLocalOperacao: 'Lugar de Operación',
		menuMissaoApoio: 'Misión de Apoyo',
		menuNomeOperacao: 'Nombre de la Operación',
		menuNovaSolicitacao: 'Nueva Solicitud',
		menuOrgaoSolicitante: 'Organización Solicitante',
		menuSolicitaNova: 'Nueva',
		menuSolicitacao: 'Solicitud',
		menuTipoOcorrencia: 'Tipo de Ocurrencia',
		naturezaEtipo: 'Ud. debe ingresar al menos una Naturaleza y Tipo.',
		novaOrdemMissao: 'Nueva Orden de Misión',
		ordemMissaoInserida: 'Nueva Orden de Misión insertada con éxito.',
		partida: 'Salida',
		removidos: 'Todos eliminados.',
		solicitaApoio: 'Solicitud',
		solicitacaoAdicionada: 'Solicitud agregada con éxito.',
		solicitacaoAtualizada: 'Solicitud actualizada con éxito.',
		statusAtualizado: 'Estado actualizado con éxito.',
	},
	menuTripOperacional: {
		carregando: 'Cargando escala operacional',
		escalaD: 'D - NORMAL',
		escalaE: 'E - EXPEDIENTE',
		escalaS: 'S - GUARDIA',
	},
	menuVoo: {
		menuVaeronave: 'Aeronave:',
		menuVaerotatico: 'Ope. Aerotáctica/ Sup. Médico',
		menuVatualizaTrechos: 'Actualizar Tramos',
		menuVatualizaTrechos2: 'Al actualizar los tramos, el sistema buscará todos los tramos del día y los incluirá en el informe de vuelo. Tramos alterados se mantendrán.',
		menuVbaseArapiraca: 'Base Arapiraca: 3530-3518',
		menuVbaseMaceio: 'Base Maceió:4009-2040',
		menuVcaesp: 'CAESP',
		menuVchefeCaesp: 'Jefe de la CAESP: 98884-7133',
		menuVchefeOp: 'Jefe de Operaciones: 98824-9657',
		menuVcodigo: 'Código',
		menuVcomb: 'Comb.',
		menuVcontato: 'Contacto:',
		menuVcorte: 'Corte',
		menuVde: 'De',
		menuVerroVoos: 'Error al cargar los vuelos del mes.',
		menuVescolha: 'Escoja la aeronave para cargar los días volados.',
		menuVestadoAlagoas: 'Estado de Alagoas',
		menuVfechaRelatorio: 'Fecha Informe',
		menuVhistorico: 'Histórico de los extractos',
		menuVmapa: 'Mapas de los Tramos',
		menuVmissao: 'Misión',
		menuVmodelo: 'Modelo',
		menuVnum: 'N°',
		menuVnumRelatorio: 'Informe N°:',
		menuVnumTrecho: 'Tramos N°',
		menuVocorrencia: 'Ocurrencia:',
		menuVpara: 'Para',
		menuVpartida: 'Partida',
		menuVpax: 'Pax.',
		menuVpousos: 'Aterrizajes',
		menuVprefixo: 'Prefijo',
		menuVreabreRelatorio: 'Reabrir Informe',
		menuVrelatorio: 'Informe de Vuelo',
		menuVsemMapa: 'No se encuentra map.a',
		menuVssp: 'SSP',
		menuVtdec: 'T Vuelo Dec',
		menuVtdesc: 'T Vuelo Décimo',
		menuVtipoMissao: 'Tipo de Misión',
		menuVtotal: 'Total',
		menuVtrechos: 'Tramos',
		menuVtvoo: 'T Vuelo',
		menuVvoo: 'T Vuelo',
	},
	nomesMes: {
		abril: 'Abril',
		agosto: 'Agosto',
		dezembro: 'Diciembre',
		fevereiro: 'Febrero',
		janeiro: 'Enero',
		julho: 'Julio',
		junho: 'Junio',
		maio: 'Mayo',
		marco: 'Marzo',
		novembro: 'Noviembre',
		outubro: 'Octubre',
		setembro: 'Septiembre',
	},
	pais: {
		alemao: 'alemán',
		brasil: 'Portugués',
		espanhol: 'Español',
		eua: 'Inglés',
		frances: 'francés',
		ingles: 'Inglés',
		italiano: 'Italiano',
		paraguai: 'Español',
		portugues: 'Portugués',
	},
	perfil: {
		PerfilInserido: 'Perfil insertado',
		clickEmNovo: 'Haga clic en \'Nuevo\'',
		editarPerfil: 'Editar Perfil',
		nomePerfil: 'Nombre de perfil',
		novoPerfil: 'Perfil nueva',
		perfilAtualizado: 'Perfil actualizado',
		perfilDoUsuario: 'Perfil de usuario',
	},
	rampa: {
		adicionar: 'Agregar',
		aeronaves: 'Aeronave',
		cabecalhoHtml: '<h3>MONITOREO DE</h3><h4 style="cursor: pointer">RAMPA</h4>',
		canac: 'CANAC',
		cpf: 'CPF',
		descricao: 'Descripción',
		digiteODesignativoDesejado: 'Escriba la designación deseada',
		digiteOQueDesejaPesquisar: 'Escriba lo que desea buscar',
		documentoComDataValida: 'El documento está dentro de la fecha de vencimiento',
		documentos: 'Documentos',
		filtrarPor: 'Filtrar por',
		menuHtml: '<div class="sub-text">MONITOREO DE</div><div class="sub-text">RAMPA</div>',
		naoExisteTripulantes: 'Use las opciones anteriores para filtrar la tripulación.',
		nenhumDesignativoEncontrado: 'No hay designaciones para mostrar',
		nenhumDocumentoEncontrado: 'No hay documentos para mostrar.',
		nenhumaAeronaveEncontrada: 'No hay aeronaves para mostrar.',
		publicacoes: 'Publicaciones',
		selecioneQuaisInformacoes: 'Seleccione qué información se mostrará',
		selecioneUmaAeronave: 'Seleccionar una aeronave',
		semDocumentosTripulante: 'No hay documentos adjuntos para esta tripulación.',
		status: 'Estado',
		tripulacao: 'Tripulación',
		tripulante: 'Tripulante',
		tripulantes: 'Tripulantes',
		ultimoDespachoDoVoo: 'Último dispacho do vuelo',
		validade: 'Validez',
		verificarDataDoDocumento: 'Compruebe la fecha de caducidad del documento',
		visualizarDiarioDeBordo: 'Ver libro de registro',
	},
	registroDadosVoo: {
		aceleracaoVertical: 'Aceleración vertical',
		altitudeAeronave: 'Aviones actitud',
		altitudeTerreno: 'Altitud Absoluta',
		altitudeVoo: 'Altitud de vuelo',
		alturaVoo: 'Altura del vuelo',
		pressaoDoOleoTurbina: 'Turbina de presión de aceite',
		pressaoOleo: 'La presión de aceite',
		proa: 'ARCO',
		torque: 'Torque',
		turbina: 'Turbina',
		variacaoTorque: 'Gama de par',
		variaveisDeMonitoramento: 'SEGUIMIENTO DE VARIABLE',
		velocidadeAeronave: 'Velocidad',
		visualizacaoGraficos: 'Gráficos de visualización',
		visualizacaoInstrumentos: 'Vista de instrumentos',
	},
	submenu: {
		ControleAtividadeAerea: 'Control de actividad aérea',
		ExtratoCompleto: 'Extracto Completo',
		aeronaves: 'Aeronaves',
		cadAcao: 'Tipo de acción de registro',
		cadAfastamento: 'Administrativo de declaración de registro',
		cadCargo: 'Posteriores a su registro',
		cadEscala: 'Registro de Escalas',
		cadEvento: 'Registro de eventos',
		cadPosto: 'Posteriores a su registro',
		cadPrevencao: 'Registro de Prevención',
		cadUser: 'Registro de Usuario',
		cadastroGrupoInspecao: 'Register Grupo de Inspección',
		comunicacaoESO: 'Gestión de riesgos',
		dataDeConclusao: 'Fecha de finalizacion',
		estatisticaVoo: 'Estadística de Vuelo',
		gestaoDoEnsino: 'Gestión de la Enseñanza',
		horasVoadas: 'Horas Voladas',
		inscricoesEMatricula: 'Inscripciones y matrículas',
		mostradores: 'Monitores',
		permutas: 'Intercambios, Licencias Médicas y Liberaciones',
		prazoParaExecucao: 'Fecha límite para la ejecución',
		relatorioOperacoes: 'Informe de Operaciones',
		relatorioPrevencao: 'Informe de Prevención',
		relatorioSolicitacoes: 'Informe de solicitudes',
		relatorioVoo: 'Informe de Vuelo',
		segurancaOperacionalEso: 'Gestión de riesgos (ESO)',
		segurancaOperacionalRac: 'Informe de aviación civil (RAC)',
		segurancaOperacionalRelPrev: 'Informe de prevención (RelPrev)',
		segurancaOperacionalRire: 'Informe inicial de respuesta de emergencia (RIRE)',
		subAdministracao: 'Administración',
		subEnsino: 'Ensino',
		subEscolar: 'Escolar',
		subOrdem: 'de Misión',
		subPagamentos: 'Pagamentos',
		subRelatorio: 'Informes',
		subRelatorioOrdem: 'Informe Orden',
		subSolicitacoes: 'Solicitudes',
		subTurmas: 'Clases',
		telaCheia: 'Pantalla Completa',
		teoricoEPratico: 'Teórico y práctico',
	},
	uploadfile: {
		arquivoRequired: 'Requerido para insertar un archivo',
		download: 'Descargar',
		erroMSG: 'No se permite este tipo de archivo',
		extPermitidas: 'Extensiones permitidas',
		foto: 'Foto',
		tituloForm: 'Anexar Archivo',
	},
}
